(function (lib, img, cjs, ss, an) {

var p; // shortcut to reference prototypes
lib.ssMetadata = [
		{name:"MWcroc_atlas_", frames: [[872,332,130,110],[568,1186,130,110],[722,210,176,120],[402,1180,164,140],[198,1182,164,140],[0,1180,196,140],[822,1174,196,140],[0,1036,196,142],[402,1036,196,142],[828,704,196,146],[204,1034,196,146],[824,1022,198,150],[824,870,198,150],[414,880,202,154],[618,1030,202,154],[620,870,202,158],[0,876,202,158],[208,706,204,162],[208,870,204,162],[0,706,206,168],[620,700,206,168],[420,526,206,172],[628,526,206,172],[0,526,208,178],[210,526,208,178],[420,700,198,178],[0,0,720,172],[0,174,720,172],[436,348,434,176],[0,348,434,176],[722,0,208,208],[836,526,176,176]]}
];


// symbols:



(lib.CrocFrontLeg0001 = function() {
	this.spriteSheet = ss["MWcroc_atlas_"];
	this.gotoAndStop(0);
}).prototype = p = new cjs.Sprite();



(lib.CrocFrontLeg0002 = function() {
	this.spriteSheet = ss["MWcroc_atlas_"];
	this.gotoAndStop(1);
}).prototype = p = new cjs.Sprite();



(lib.CrocHindLegUpper = function() {
	this.spriteSheet = ss["MWcroc_atlas_"];
	this.gotoAndStop(2);
}).prototype = p = new cjs.Sprite();



(lib.CrocLowerHindLeg0001 = function() {
	this.spriteSheet = ss["MWcroc_atlas_"];
	this.gotoAndStop(3);
}).prototype = p = new cjs.Sprite();



(lib.CrocLowerHindLeg0002 = function() {
	this.spriteSheet = ss["MWcroc_atlas_"];
	this.gotoAndStop(4);
}).prototype = p = new cjs.Sprite();



(lib.CrocodileHead_0010001 = function() {
	this.spriteSheet = ss["MWcroc_atlas_"];
	this.gotoAndStop(5);
}).prototype = p = new cjs.Sprite();



(lib.CrocodileHead_0010002 = function() {
	this.spriteSheet = ss["MWcroc_atlas_"];
	this.gotoAndStop(6);
}).prototype = p = new cjs.Sprite();



(lib.CrocodileHead_0020001 = function() {
	this.spriteSheet = ss["MWcroc_atlas_"];
	this.gotoAndStop(7);
}).prototype = p = new cjs.Sprite();



(lib.CrocodileHead_0020002 = function() {
	this.spriteSheet = ss["MWcroc_atlas_"];
	this.gotoAndStop(8);
}).prototype = p = new cjs.Sprite();



(lib.CrocodileHead_0030001 = function() {
	this.spriteSheet = ss["MWcroc_atlas_"];
	this.gotoAndStop(9);
}).prototype = p = new cjs.Sprite();



(lib.CrocodileHead_0030002 = function() {
	this.spriteSheet = ss["MWcroc_atlas_"];
	this.gotoAndStop(10);
}).prototype = p = new cjs.Sprite();



(lib.CrocodileHead_0040001 = function() {
	this.spriteSheet = ss["MWcroc_atlas_"];
	this.gotoAndStop(11);
}).prototype = p = new cjs.Sprite();



(lib.CrocodileHead_0040002 = function() {
	this.spriteSheet = ss["MWcroc_atlas_"];
	this.gotoAndStop(12);
}).prototype = p = new cjs.Sprite();



(lib.CrocodileHead_0050001 = function() {
	this.spriteSheet = ss["MWcroc_atlas_"];
	this.gotoAndStop(13);
}).prototype = p = new cjs.Sprite();



(lib.CrocodileHead_0050002 = function() {
	this.spriteSheet = ss["MWcroc_atlas_"];
	this.gotoAndStop(14);
}).prototype = p = new cjs.Sprite();



(lib.CrocodileHead_0060001 = function() {
	this.spriteSheet = ss["MWcroc_atlas_"];
	this.gotoAndStop(15);
}).prototype = p = new cjs.Sprite();



(lib.CrocodileHead_0060002 = function() {
	this.spriteSheet = ss["MWcroc_atlas_"];
	this.gotoAndStop(16);
}).prototype = p = new cjs.Sprite();



(lib.CrocodileHead_0070001 = function() {
	this.spriteSheet = ss["MWcroc_atlas_"];
	this.gotoAndStop(17);
}).prototype = p = new cjs.Sprite();



(lib.CrocodileHead_0070002 = function() {
	this.spriteSheet = ss["MWcroc_atlas_"];
	this.gotoAndStop(18);
}).prototype = p = new cjs.Sprite();



(lib.CrocodileHead_0080001 = function() {
	this.spriteSheet = ss["MWcroc_atlas_"];
	this.gotoAndStop(19);
}).prototype = p = new cjs.Sprite();



(lib.CrocodileHead_0080002 = function() {
	this.spriteSheet = ss["MWcroc_atlas_"];
	this.gotoAndStop(20);
}).prototype = p = new cjs.Sprite();



(lib.CrocodileHead_0090001 = function() {
	this.spriteSheet = ss["MWcroc_atlas_"];
	this.gotoAndStop(21);
}).prototype = p = new cjs.Sprite();



(lib.CrocodileHead_0090002 = function() {
	this.spriteSheet = ss["MWcroc_atlas_"];
	this.gotoAndStop(22);
}).prototype = p = new cjs.Sprite();



(lib.CrocodileHead_0100001 = function() {
	this.spriteSheet = ss["MWcroc_atlas_"];
	this.gotoAndStop(23);
}).prototype = p = new cjs.Sprite();



(lib.CrocodileHead_0100002 = function() {
	this.spriteSheet = ss["MWcroc_atlas_"];
	this.gotoAndStop(24);
}).prototype = p = new cjs.Sprite();



(lib.CrocodileNeck = function() {
	this.spriteSheet = ss["MWcroc_atlas_"];
	this.gotoAndStop(25);
}).prototype = p = new cjs.Sprite();



(lib.CrocodileTail0001 = function() {
	this.spriteSheet = ss["MWcroc_atlas_"];
	this.gotoAndStop(26);
}).prototype = p = new cjs.Sprite();



(lib.CrocodileTail0002 = function() {
	this.spriteSheet = ss["MWcroc_atlas_"];
	this.gotoAndStop(27);
}).prototype = p = new cjs.Sprite();



(lib.CrocodileTorso0001 = function() {
	this.spriteSheet = ss["MWcroc_atlas_"];
	this.gotoAndStop(28);
}).prototype = p = new cjs.Sprite();



(lib.CrocodileTorso0002 = function() {
	this.spriteSheet = ss["MWcroc_atlas_"];
	this.gotoAndStop(29);
}).prototype = p = new cjs.Sprite();



(lib.M_Wash_Bubble = function() {
	this.spriteSheet = ss["MWcroc_atlas_"];
	this.gotoAndStop(30);
}).prototype = p = new cjs.Sprite();



(lib.M_Wash_Bubble_pop = function() {
	this.spriteSheet = ss["MWcroc_atlas_"];
	this.gotoAndStop(31);
}).prototype = p = new cjs.Sprite();
// helper functions:

function mc_symbol_clone() {
	var clone = this._cloneProps(new this.constructor(this.mode, this.startPosition, this.loop));
	clone.gotoAndStop(this.currentFrame);
	clone.paused = this.paused;
	clone.framerate = this.framerate;
	return clone;
}

function getMCSymbolPrototype(symbol, nominalBounds, frameBounds) {
	var prototype = cjs.extend(symbol, cjs.MovieClip);
	prototype.clone = mc_symbol_clone;
	prototype.nominalBounds = nominalBounds;
	prototype.frameBounds = frameBounds;
	return prototype;
	}


(lib.Wet_drop = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#91D6F7").s().p("AgeBSQgPgSgCgjQgCgiAkheQA2BhAFAgQAFAkgOARQgOARgUAAQgTAAgOgSg");
	this.shape.setTransform(4.8,10);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(0,0,9.6,20);


(lib.SmallStar = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#FFFF99").s().p("Ag1BSQgGgDAFgaIAHgaIgVgVQgVgUADgFQACgFAbgFIAbgFIAMgYQAOgYAEAAQAHAAAYAyIAbADQAbAEACAGQAEAJgtAlQAPAzgHAEQgHAEgvgaQgkAXgNAAIgEgBg");

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-8.7,-8.3,17.6,16.7);


(lib.LargeStar = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#FFFF99").s().p("AhGBuQgJgFAHgjIAJgiIgcgbQgbgcADgGQADgHAkgHIAjgGIARggQATghAFABQAKgBAgBDIAjAEQAkAGADAIQAFAMg7AxQAUBEgKAGQgKAFg+gjQgwAegRAAIgFAAg");

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-11.6,-11,23.4,22.1);


(lib.sparkle = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#FFFFFF").s().p("AgZAGQAYgRABg2QACA2AYANQgWAVgDArQgIgxgSgLg");
	this.shape.setTransform(-0.1,1);

	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.f("#FFFFFF").s().p("AggAkQgLgQgMgHQANgKAKgOQAdgsADhXQAEBYAeAoQAJAMAMAHIABAAQgNALgJAQQgaApgFBFIAAABQgNhJgWgig");
	this.shape_1.setTransform(-0.1,1);

	this.shape_2 = new cjs.Shape();
	this.shape_2.graphics.f("#FFFFFF").s().p("AgyA5QgQgZgTgMQAUgPAPgWQAthEAFiHQAGCJAvA9QAOAUASAKQgSASgOAYQgpBAgHBrQgVhwgig0gAgZAGQASALAIAxQAEgsAVgUQgYgNgCg3QgBA3gYARg");
	this.shape_2.setTransform(-0.1,1);

	this.shape_3 = new cjs.Shape();
	this.shape_3.graphics.f("#FFFFFF").s().p("Ag0BYQA1AmAzgmQgnBAgHBqQgWh2gkg0gAhxAKQATgNAPgYQgVAlAVAlQgQgZgSgMgABRgfQAOATATALQgTARgOAYQAUglgUgigAgrhAQAnhDAEh9QAHCDAqA9QgugpguApg");
	this.shape_3.setTransform(-0.2,2);

	this.shape_4 = new cjs.Shape();
	this.shape_4.graphics.f("#FFFFFF").s().p("AgMC8QAQAaAOgaQgIAlgEAtQgHgugLgkgAh7ALIASgPQgMARALAMQgIgJgJgFgABvgJIANAJIgNAMQAIgMgIgJgAgJisQAIgrABg2QADA3AJAqQgLgOgKAOg");
	this.shape_4.setTransform(-0.3,1.9);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape}]}).to({state:[{t:this.shape_1}]},1).to({state:[{t:this.shape_2}]},1).to({state:[{t:this.shape_3}]},1).to({state:[{t:this.shape_4}]},1).to({state:[]},1).wait(45));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-2.7,-5.7,5.2,13.3);


(lib.M_Wash_Bubble_pop_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 2
	this.instance = new lib.M_Wash_Bubble_pop();
	this.instance.parent = this;
	this.instance.setTransform(-9,-9,0.25,0.25);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f().s("#FFFFFF").ss(1.9,1,1).p("AAtACIARAAAACg9IAAAUAAgghIAJgMAg9AAIAYgBAgmgrIANAPAgrArIALgNAgEAwIAAAOAAdAoIAKAN");
	this.shape.setTransform(11.2,10.6);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = getMCSymbolPrototype(lib.M_Wash_Bubble_pop_1, new cjs.Rectangle(-9,-9,44,44), null);


(lib.M_Wash_Bubble_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 2
	this.instance = new lib.M_Wash_Bubble();
	this.instance.parent = this;
	this.instance.setTransform(-13,-13,0.25,0.25);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.M_Wash_Bubble_1, new cjs.Rectangle(-13,-13,52,52), null);


(lib.invisiblebox = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("rgba(255,255,255,0)").s().p("AhwDIIhZgEIAEmHIBOgEIDvAAIBSABIgCGKIhGAEg");
	this.shape.setTransform(-0.3,0);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = getMCSymbolPrototype(lib.invisiblebox, new cjs.Rectangle(-20.5,-20,40.4,40), null);


(lib.croc_tailGlow = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f().s("#FFFF00").ss(6,1,1).p("ASfCBIgBAAQgFgFgIgJQgPgQgEAAQgJAEgSAAQgDAAgEgIQgFgIgRAAQgEAAgIAEQgJAEgEAAQgFgGgHgGQgPgNgNABQgDAAgGADQgGADgDAAQgEAAgNgJQgOgJgVABQgEAAgGADQgHADgEAAQgHAAgDgDQgDgDgDgCQgMgHg2ABQgKgGgMgFQgGgFgHgBQgJgCghAEQgGgBgFAAQgHgIgHgHQgQgPgUABQgUAAgcAIQgGACgFACQgBgCgEgEQgFgDgSgMQgRgNgnADQgmAEgMAMQgKgGgKgFQgUgLgZAAQgbABgQAIQgIAEgKAIQgMgKgRgLQgigWgcABQgUAAgMAOQgPgNgQgLQgegWgRABQgQAAgKAKQgJAKgEAAQgMgIgOgJQgdgRgQABQgHAAgXAMQgQAIgKAHQgGgJgbgNQgagNgLABQgMAAgcAPQgOAHgLAHQgKAAgUgRQgTgRgTABQgMABgYAQQgMAHgGAGQgDgLgTgSQgUgSgjACQgBAAgBAAIgwARQgFAEgEAEQgVgDgUgDQgIgMgOgLQgVgPgXgDQgYgDghAJQghAJgEABQgDAAgCAAQgGgBgGgBQgCgBgBAAQgpg2gzAEQgyAFgPAUQgIgBgHgBQgDgQgagTQgfgWgjgDQgigDgUAEQgUAFgKAFQg+g1gXgGQgXgGglAPQgmAPgCAAQgLAAgbgcQgbgbgvAhQgxA2AUBqQBbAfAnBiQAoBkh1BhIBvANQAGABAGABQBtANBPAEQAyADCCAAIB5gBQADACDOgJICwgOIDcgXQAXgDAagDQAEAAAKgBIAzgDQAAAAABAAQABAAABAAQACAAACAAIAAAAQA5gDAqAAQAQgBBGgEQE3gQA6gFIHrgOQAGAAAdgFQAGgBAGgBQAJAAAIABQASACgYgFQAOgDAKgDQAQgEgWgHIgEgBQAAgBgBAAQgCAAgCgBQgYgGAAgBQAAgIgGgGQgHgFgPADQgMADADAGg");
	this.shape.setTransform(133,27);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = getMCSymbolPrototype(lib.croc_tailGlow, new cjs.Rectangle(3.4,-3,259.2,60), null);


(lib.croc_mouthGlow = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f().s("#FFFF00").ss(6,1,1).p("AkghMQACASgRAMQgUANAAANQAAAQALATQANAZARAFQACABADABQAAAFASAMQATAMBzAPQBzAOAbAEQAbAEAvAEQBtAMAqgaQApgYATgTQAegegKgWQgTglglgOQgNgEgbgDQgngChMgNQhFgMAAAAQhbgXhjADQgEABgEABQgBAAgBAAQgjAEgSgRQgOgPgbAFQggAFgEAj");
	this.shape.setTransform(32.4,12);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = getMCSymbolPrototype(lib.croc_mouthGlow, new cjs.Rectangle(-3,-3,70.9,30.1), null);


(lib.croc_footGlow = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f().s("#FFFF00").ss(6,1,1).p("AKcADQABAAAAABQAIgUAEgUQhOgqhuAUQACABADACQgDAAgCAAQgVACiTAsQijAxAAATQABAHArALQAFAiABABQCYgiAogFIBmgCQAgAAAbgCQA0gDATgUQAIgIAKgNQAKgOADgGQABgBAAgBgAn8hCQgPAfhBgHQgegEgPABQgRABAEAHQAGAIAHAHQAFAGAGAFQgGACgFADQggALgJAFQgKAFAFALQAHALAOABQAMAAANABQACAAADABQgDACgCADQgLANgGAJQgIAMAHAFQAHAGALABQACABADAAQAJgBAggOQAdgMAGAIIAAANQABAYAOgIQAOgIANgKQAMgMATgSQBDAUA5gtQA6gsg7g1Qg6g0goAMQgnALgPAfg");
	this.shape.setTransform(-16.2,6.5);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = getMCSymbolPrototype(lib.croc_footGlow, new cjs.Rectangle(-87.3,-7.6,142.3,28.3), null);


(lib.croc_backGlow = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f().s("#FFFF00").ss(6,1,1).p("AINhXQgdgXgWABQgXAAgUAGQgRAFgBAAQgTgOgOgFQgMgHgIgDQgPgGgZABQgUAAgQAGQgPAGgEAAQgQgJgTgJQgmgRgTAAQgQABgJACQgPAEgJACQggAMAAAAQgEAAgSgIQgSgJgZgIQgagIgUAHQgWAGgoATQgBAAgVgKQgVgLgQgCIgoAAQgSACgiATIggASQg/gMgHgBQgYgFgSAGQgQAEgRAMQgQAKgDABIgbgIQgSgIgYAJQgkAYgGAHQgNAMABASIAAAXQANDyJzhAQA1hwDNAQQDNAQAAhEQABhEgcgWg");
	this.shape.setTransform(87.5,16.4);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = getMCSymbolPrototype(lib.croc_backGlow, new cjs.Rectangle(29.3,-3,116.5,38.9), null);


(lib.blueglowtail = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f().s("#0099FF").ss(6,1,1).p("ASfCBIgBAAQgFgFgIgJQgPgQgEAAQgJAEgSAAQgDAAgEgIQgFgIgRAAQgEAAgIAEQgJAEgEAAQgFgGgHgGQgPgNgNABQgDAAgGADQgGADgDAAQgEAAgNgJQgOgJgVABQgEAAgGADQgHADgEAAQgHAAgDgDQgDgDgDgCQgMgHg2ABQgKgGgMgFQgGgFgHgBQgJgCghAEQgGgBgFAAQgHgIgHgHQgQgPgUABQgUAAgcAIQgGACgFACQgBgCgEgEQgFgDgSgMQgRgNgnADQgmAEgMAMQgKgGgKgFQgUgLgZAAQgbABgQAIQgIAEgKAIQgMgKgRgLQgigWgcABQgUAAgMAOQgPgNgQgLQgegWgRABQgQAAgKAKQgJAKgEAAQgMgIgOgJQgdgRgQABQgHAAgXAMQgQAIgKAHQgGgJgbgNQgagNgLABQgMAAgcAPQgOAHgLAHQgKAAgUgRQgTgRgTABQgMABgYAQQgMAHgGAGQgDgLgTgSQgUgSgjACQgBAAgBAAIgwARQgFAEgEAEQgVgDgUgDQgIgMgOgLQgVgPgXgDQgYgDghAJQghAJgEABQgDAAgCAAQgGgBgGgBQgCgBgBAAQgpg2gzAEQgyAFgPAUQgIgBgHgBQgDgQgagTQgfgWgjgDQgigDgUAEQgUAFgKAFQg+g1gXgGQgXgGglAPQgmAPgCAAQgLAAgbgcQgbgbgvAhQgxA2AUBqQBbAfAnBiQAoBkh1BhIBvANQAGABAGABQBtANBPAEQAyADCCAAIB5gBQADACDOgJICwgOIDcgXQAXgDAagDQAEAAAKgBIAzgDQAAAAABAAQABAAABAAQACAAACAAIAAAAQA5gDAqAAQAQgBBGgEQE3gQA6gFIHrgOQAGAAAdgFQAGgBAGgBQAJAAAIABQASACgYgFQAOgDAKgDQAQgEgWgHIgEgBQAAgBgBAAQgCAAgCgBQgYgGAAgBQAAgIgGgGQgHgFgPADQgMADADAGg");
	this.shape.setTransform(133,27);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = getMCSymbolPrototype(lib.blueglowtail, new cjs.Rectangle(3.4,-3,259.2,60), null);


(lib.blueglowmouth = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f().s("#0099FF").ss(6,1,1).p("AkghMQACASgRAMQgUANAAANQAAAQALATQANAZARAFQACABADABQAAAFASAMQATAMBzAPQBzAOAbAEQAbAEAvAEQBtAMAqgaQApgYATgTQAegegKgWQgTglglgOQgNgEgbgDQgngChMgNQhFgMAAAAQhbgXhjADQgEABgEABQgBAAgBAAQgjAEgSgRQgOgPgbAFQggAFgEAj");
	this.shape.setTransform(32.4,12);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = getMCSymbolPrototype(lib.blueglowmouth, new cjs.Rectangle(-3,-3,70.9,30.1), null);


(lib.blueglowback = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f().s("#0099FF").ss(6,1,1).p("AINhXQgdgXgWABQgXAAgUAGQgRAFgBAAQgTgOgOgFQgMgHgIgDQgPgGgZABQgUAAgQAGQgPAGgEAAQgQgJgTgJQgmgRgTAAQgQABgJACQgPAEgJACQggAMAAAAQgEAAgSgIQgSgJgZgIQgagIgUAHQgWAGgoATQgBAAgVgKQgVgLgQgCIgoAAQgSACgiATIggASQg/gMgHgBQgYgFgSAGQgQAEgRAMQgQAKgDABIgbgIQgSgIgYAJQgkAYgGAHQgNAMABASIAAAXQANDyJzhAQA1hwDNAQQDNAQAAhEQABhEgcgWg");
	this.shape.setTransform(87.5,16.4);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = getMCSymbolPrototype(lib.blueglowback, new cjs.Rectangle(29.3,-3,116.5,38.9), null);


(lib.bluefootglow = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f().s("#0099FF").ss(6,1,1).p("AKcADQABAAAAABQAIgUAEgUQhOgqhuAUQACABADACQgDAAgCAAQgVACiTAsQijAxAAATQABAHArALQAFAiABABQCYgiAogFIBmgCQAgAAAbgCQA0gDATgUQAIgIAKgNQAKgOADgGQABgBAAgBgAn8hCQgPAfhBgHQgegEgPABQgRABAEAHQAGAIAHAHQAFAGAGAFQgGACgFADQggALgJAFQgKAFAFALQAHALAOABQAMAAANABQACAAADABQgDACgCADQgLANgGAJQgIAMAHAFQAHAGALABQACABADAAQAJgBAggOQAdgMAGAIIAAANQABAYAOgIQAOgIANgKQAMgMATgSQBDAUA5gtQA6gsg7g1Qg6g0goAMQgnALgPAfg");
	this.shape.setTransform(-16.2,6.5);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = getMCSymbolPrototype(lib.bluefootglow, new cjs.Rectangle(-87.3,-7.6,142.3,28.3), null);


(lib.CrocodileNeck_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Crocodile Neck.png
	this.instance = new lib.CrocodileNeck();
	this.instance.parent = this;
	this.instance.setTransform(-45.8,-40.2,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(2));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-47,-40.2,101,89);


(lib.CrocHindLegUpper_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 2
	this.instance = new lib.CrocHindLegUpper();
	this.instance.parent = this;
	this.instance.setTransform(-4,-4,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(2));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-4,-4,88,60);


(lib.star_2_anim = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Star
	this.instance = new lib.SmallStar("synched",0);
	this.instance.parent = this;
	this.instance.setTransform(0.1,0.3,0.6,0.6);

	this.timeline.addTween(cjs.Tween.get(this.instance).to({guide:{path:[0.1,0.2,-4.2,-0.7,-6.2,-1.6,-9.1,-2.8,-9.1,-4.5,-9.1,-6.3,-6,-7.7,-4.2,-8.6,0.7,-10,5.6,-11.4,7.5,-12.3,10.6,-13.8,10.6,-15.6,10.6,-17.5,7.3,-18.9,5.3,-19.8,0.1,-21.1,-5.1,-22.4,-7,-23.2,-10.3,-24.5,-10.3,-26.3,-10.3,-28,-7.2,-29.3,-5.7,-30,-1.7,-31.1], orient:'auto'},alpha:0.102},16).wait(1));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-5.1,-4.7,10.5,10);


(lib.star_1_anim = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Star
	this.instance = new lib.LargeStar("synched",0);
	this.instance.parent = this;
	this.instance.setTransform(0.1,0.3,0.6,0.6);

	this.timeline.addTween(cjs.Tween.get(this.instance).to({guide:{path:[0.1,0.2,4.5,-0.7,6.5,-1.6,9.4,-2.8,9.4,-4.5,9.4,-6.3,6.3,-7.7,4.5,-8.6,-0.4,-10,-5.3,-11.4,-7.2,-12.3,-10.3,-13.8,-10.3,-15.6,-10.3,-17.5,-7,-18.9,-5,-19.8,0.1,-21.1,5.4,-22.4,7.3,-23.2,10.6,-24.5,10.6,-26.3,10.6,-28,7.5,-29.3,6,-30,2,-31.1], orient:'auto'},alpha:0.102},13).wait(1));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-6.9,-6.4,14,13.3);


(lib.sparkle2 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.innerSparkle = new lib.star_2_anim();
	this.innerSparkle.parent = this;

	this.timeline.addTween(cjs.Tween.get(this.innerSparkle).wait(1));

}).prototype = getMCSymbolPrototype(lib.sparkle2, new cjs.Rectangle(-5.2,-4.7,10.6,10), null);


(lib.sparkle1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.innerSparkle = new lib.star_1_anim();
	this.innerSparkle.parent = this;

	this.timeline.addTween(cjs.Tween.get(this.innerSparkle).wait(1));

}).prototype = getMCSymbolPrototype(lib.sparkle1, new cjs.Rectangle(-6.9,-6.4,14,13.3), null);


(lib.Running_drop = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.instance = new lib.Wet_drop();
	this.instance.parent = this;
	this.instance.setTransform(4.8,10,1,1,0,0,0,4.8,10);
	this.instance.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,4);
	new cjs.ButtonHelper(this.instance, 0, 1, 1);

	this.timeline.addTween(cjs.Tween.get(this.instance).to({y:146.2},15).to({regX:4.5,scaleX:0.1,scaleY:0.1,y:182.5},4).to({_off:true},1).wait(5));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-10,-10,37,48);


(lib.left_over_bubbles_sparse = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 15
	this.instance = new lib.M_Wash_Bubble_1();
	this.instance.parent = this;
	this.instance.setTransform(59.6,9,0.075,0.075,-155.3,0,0,11.1,11.2);
	this.instance.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_1 = new lib.M_Wash_Bubble_1();
	this.instance_1.parent = this;
	this.instance_1.setTransform(46.5,10.1,0.439,0.439,-153.7,0,0,11.2,11.1);
	this.instance_1.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_2 = new lib.M_Wash_Bubble_1();
	this.instance_2.parent = this;
	this.instance_2.setTransform(55.1,9,0.162,0.162,-155.3,0,0,11.2,11.2);
	this.instance_2.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_3 = new lib.M_Wash_Bubble_1();
	this.instance_3.parent = this;
	this.instance_3.setTransform(38.2,13,0.188,0.188,-155.4,0,0,11.1,10.7);
	this.instance_3.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_4 = new lib.M_Wash_Bubble_1();
	this.instance_4.parent = this;
	this.instance_4.setTransform(40.7,8.6,0.28,0.28,-155.4,0,0,11.2,11.2);
	this.instance_4.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_5 = new lib.M_Wash_Bubble_1();
	this.instance_5.parent = this;
	this.instance_5.setTransform(36.5,10.9,0.165,0.165,0,0,0,11,11);
	this.instance_5.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_5},{t:this.instance_4},{t:this.instance_3},{t:this.instance_2},{t:this.instance_1},{t:this.instance}]}).wait(1));

}).prototype = getMCSymbolPrototype(lib.left_over_bubbles_sparse, new cjs.Rectangle(23.8,-13.3,50.1,48), null);


(lib.left_over_bubbles_few = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 15
	this.instance = new lib.M_Wash_Bubble_1();
	this.instance.parent = this;
	this.instance.setTransform(42.3,6.2,0.075,0.075,-155.3,0,0,11,11.2);
	this.instance.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_1 = new lib.M_Wash_Bubble_1();
	this.instance_1.parent = this;
	this.instance_1.setTransform(43.3,4.3,0.075,0.075,-155.3,0,0,11,11.2);
	this.instance_1.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_2 = new lib.M_Wash_Bubble_1();
	this.instance_2.parent = this;
	this.instance_2.setTransform(39.9,6.5,0.075,0.075,-155.3,0,0,11.1,11.2);
	this.instance_2.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_3 = new lib.M_Wash_Bubble_1();
	this.instance_3.parent = this;
	this.instance_3.setTransform(54,11,0.075,0.075,-155.3,0,0,11,11.2);
	this.instance_3.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_4 = new lib.M_Wash_Bubble_1();
	this.instance_4.parent = this;
	this.instance_4.setTransform(46.5,10.1,0.439,0.439,-153.7,0,0,11.2,11.1);
	this.instance_4.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_5 = new lib.M_Wash_Bubble_1();
	this.instance_5.parent = this;
	this.instance_5.setTransform(52.8,6.1,0.28,0.28,-155.4,0,0,11.2,11.2);
	this.instance_5.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_5},{t:this.instance_4},{t:this.instance_3},{t:this.instance_2},{t:this.instance_1},{t:this.instance}]}).wait(1));

}).prototype = getMCSymbolPrototype(lib.left_over_bubbles_few, new cjs.Rectangle(23.8,-13.3,50.1,48), null);


(lib.left_over_bubbles_2 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 15
	this.instance = new lib.M_Wash_Bubble_1();
	this.instance.parent = this;
	this.instance.setTransform(45.6,4.1,0.326,0.326,-155.4,0,0,11.3,11.2);
	this.instance.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_1 = new lib.M_Wash_Bubble_1();
	this.instance_1.parent = this;
	this.instance_1.setTransform(52.8,6.1,0.28,0.28,-155.4,0,0,11.2,11.2);
	this.instance_1.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_1},{t:this.instance}]}).wait(1));

}).prototype = getMCSymbolPrototype(lib.left_over_bubbles_2, new cjs.Rectangle(27.1,-14.9,46.8,40.7), null);


(lib.left_over_bubbles = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 15
	this.instance = new lib.M_Wash_Bubble_1();
	this.instance.parent = this;
	this.instance.setTransform(70.8,4,0.404,0.404,4.9,0,0,11.1,10.3);
	this.instance.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_1 = new lib.M_Wash_Bubble_1();
	this.instance_1.parent = this;
	this.instance_1.setTransform(64.4,1.4,0.289,0.289,4.9,0,0,11.1,10.3);
	this.instance_1.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_2 = new lib.M_Wash_Bubble_1();
	this.instance_2.parent = this;
	this.instance_2.setTransform(31,4.8,0.289,0.289,4.9,0,0,11.1,10);
	this.instance_2.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_3 = new lib.M_Wash_Bubble_1();
	this.instance_3.parent = this;
	this.instance_3.setTransform(29.7,12.7,0.431,0.431,4.9,0,0,11.3,11.2);
	this.instance_3.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_4 = new lib.M_Wash_Bubble_1();
	this.instance_4.parent = this;
	this.instance_4.setTransform(34.6,7,0.253,0.253,160.3,0,0,10.8,10.8);
	this.instance_4.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_5 = new lib.M_Wash_Bubble_1();
	this.instance_5.parent = this;
	this.instance_5.setTransform(55.1,9,0.162,0.162,-155.3,0,0,11.2,11.2);
	this.instance_5.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_6 = new lib.M_Wash_Bubble_1();
	this.instance_6.parent = this;
	this.instance_6.setTransform(47.2,-5.1,0.267,0.267,-155.4,0,0,11.5,11.1);
	this.instance_6.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_7 = new lib.M_Wash_Bubble_1();
	this.instance_7.parent = this;
	this.instance_7.setTransform(20.1,12.2,0.221,0.221,-155.4,0,0,11.3,11);
	this.instance_7.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_8 = new lib.M_Wash_Bubble_1();
	this.instance_8.parent = this;
	this.instance_8.setTransform(20.2,17,0.162,0.162,-155.3,0,0,11.2,11.1);
	this.instance_8.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_9 = new lib.M_Wash_Bubble_1();
	this.instance_9.parent = this;
	this.instance_9.setTransform(38.2,13,0.188,0.188,-155.4,0,0,11.1,10.7);
	this.instance_9.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_10 = new lib.M_Wash_Bubble_1();
	this.instance_10.parent = this;
	this.instance_10.setTransform(40.7,8.6,0.28,0.28,-155.4,0,0,11.2,11.2);
	this.instance_10.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_11 = new lib.M_Wash_Bubble_1();
	this.instance_11.parent = this;
	this.instance_11.setTransform(82.6,4.9,0.124,0.124,-155.3,0,0,10.5,11.2);
	this.instance_11.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_12 = new lib.M_Wash_Bubble_1();
	this.instance_12.parent = this;
	this.instance_12.setTransform(36.5,10.9,0.165,0.165,0,0,0,11,11);
	this.instance_12.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_12},{t:this.instance_11},{t:this.instance_10},{t:this.instance_9},{t:this.instance_8},{t:this.instance_7},{t:this.instance_6},{t:this.instance_5},{t:this.instance_4},{t:this.instance_3},{t:this.instance_2},{t:this.instance_1},{t:this.instance}]}).wait(1));

}).prototype = getMCSymbolPrototype(lib.left_over_bubbles, new cjs.Rectangle(5.3,-21.9,91.8,57.3), null);


(lib.Bubbles_together = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// M_Wash_Bubble
	this.instance = new lib.M_Wash_Bubble_1();
	this.instance.parent = this;
	this.instance.setTransform(30.1,18.9,0.303,0.303,-155.3,0,0,11,10.9);
	this.instance.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_1 = new lib.M_Wash_Bubble_pop_1();
	this.instance_1.parent = this;
	this.instance_1.setTransform(30.2,18.9,0.757,0.757,-155.3,0,0,10.9,11);
	this.instance_1.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance}]},38).to({state:[{t:this.instance_1}]},2).to({state:[]},2).wait(50));
	this.timeline.addTween(cjs.Tween.get(this.instance).to({regX:10.9,regY:11,scaleX:0.76,scaleY:0.76,x:30.2},38).to({_off:true},2).wait(52));

	// M_Wash_Bubble
	this.instance_2 = new lib.M_Wash_Bubble_1();
	this.instance_2.parent = this;
	this.instance_2.setTransform(24.5,20.9,0.313,0.313,-155.3,0,0,11.1,11.1);
	this.instance_2.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_3 = new lib.M_Wash_Bubble_pop_1();
	this.instance_3.parent = this;
	this.instance_3.setTransform(24.6,20.9,0.757,0.757,-155.3,0,0,11,11);
	this.instance_3.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_2}]}).to({state:[{t:this.instance_2}]},40).to({state:[{t:this.instance_3}]},2).to({state:[]},2).wait(48));
	this.timeline.addTween(cjs.Tween.get(this.instance_2).to({regX:11,regY:11,scaleX:0.76,scaleY:0.76,x:24.6},40).to({_off:true},2).wait(50));

	// M_Wash_Bubble
	this.instance_4 = new lib.M_Wash_Bubble_1();
	this.instance_4.parent = this;
	this.instance_4.setTransform(39.6,16.1,0.287,0.287,-155.3,0,0,10.8,10.8);
	this.instance_4.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_5 = new lib.M_Wash_Bubble_pop_1();
	this.instance_5.parent = this;
	this.instance_5.setTransform(39.6,16.1,0.757,0.757,-155.3,0,0,11,11);
	this.instance_5.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_4}]}).to({state:[{t:this.instance_4}]},34).to({state:[{t:this.instance_5}]},2).to({state:[]},2).wait(54));
	this.timeline.addTween(cjs.Tween.get(this.instance_4).to({regX:11,regY:11,scaleX:0.76,scaleY:0.76},34).to({_off:true},2).wait(56));

	// M_Wash_Bubble
	this.instance_6 = new lib.M_Wash_Bubble_1();
	this.instance_6.parent = this;
	this.instance_6.setTransform(9.9,-2.5,0.199,0.199,-155.3,0,0,11,10.7);
	this.instance_6.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_7 = new lib.M_Wash_Bubble_pop_1();
	this.instance_7.parent = this;
	this.instance_7.setTransform(9.8,-2.5,0.757,0.757,-155.3,0,0,11.1,11);
	this.instance_7.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_6}]}).to({state:[{t:this.instance_7}]},32).to({state:[{t:this.instance_7}]},2).to({state:[]},2).wait(56));
	this.timeline.addTween(cjs.Tween.get(this.instance_6).to({_off:true,regX:11.1,regY:11,scaleX:0.76,scaleY:0.76,x:9.8},32).wait(60));

	// M_Wash_Bubble
	this.instance_8 = new lib.M_Wash_Bubble_1();
	this.instance_8.parent = this;
	this.instance_8.setTransform(25.7,-1.5,0.162,0.162,-155.3,0,0,11.2,11.2);
	this.instance_8.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_9 = new lib.M_Wash_Bubble_pop_1();
	this.instance_9.parent = this;
	this.instance_9.setTransform(25.6,-1.5,0.757,0.757,-155.3,0,0,11.1,11);
	this.instance_9.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_8}]}).to({state:[{t:this.instance_9}]},36).to({state:[{t:this.instance_9}]},2).to({state:[]},2).wait(52));
	this.timeline.addTween(cjs.Tween.get(this.instance_8).to({_off:true,regX:11.1,regY:11,scaleX:0.76,scaleY:0.76,x:25.6},36).wait(56));

	// M_Wash_Bubble
	this.instance_10 = new lib.M_Wash_Bubble_1();
	this.instance_10.parent = this;
	this.instance_10.setTransform(22.2,6,0.108,0.108,-155.3,0,0,11.1,11.8);
	this.instance_10.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_11 = new lib.M_Wash_Bubble_pop_1();
	this.instance_11.parent = this;
	this.instance_11.setTransform(22,6,0.757,0.757,-155.3,0,0,11.2,10.9);
	this.instance_11.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_10}]}).to({state:[{t:this.instance_11}]},30).to({state:[{t:this.instance_11}]},2).to({state:[]},2).wait(58));
	this.timeline.addTween(cjs.Tween.get(this.instance_10).to({_off:true,regX:11.2,regY:10.9,scaleX:0.76,scaleY:0.76,x:22},30).wait(62));

	// M_Wash_Bubble
	this.instance_12 = new lib.M_Wash_Bubble_1();
	this.instance_12.parent = this;
	this.instance_12.setTransform(29.2,-9,0.119,0.119,-155.3,0,0,11.5,11);
	this.instance_12.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_13 = new lib.M_Wash_Bubble_pop_1();
	this.instance_13.parent = this;
	this.instance_13.setTransform(29.1,-9,0.757,0.757,-155.3,0,0,11.1,11);
	this.instance_13.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_12}]}).to({state:[{t:this.instance_13}]},32).to({state:[{t:this.instance_13}]},2).to({state:[]},2).wait(56));
	this.timeline.addTween(cjs.Tween.get(this.instance_12).to({_off:true,regX:11.1,scaleX:0.76,scaleY:0.76,x:29.1},32).wait(60));

	// M_Wash_Bubble
	this.instance_14 = new lib.M_Wash_Bubble_1();
	this.instance_14.parent = this;
	this.instance_14.setTransform(42.2,-3.1,0.271,0.271,-155.3,0,0,10.3,11.3);
	this.instance_14.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_15 = new lib.M_Wash_Bubble_pop_1();
	this.instance_15.parent = this;
	this.instance_15.setTransform(42.2,-3.1,0.757,0.757,-155.3,0,0,11,11.1);
	this.instance_15.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_14}]}).to({state:[{t:this.instance_15}]},30).to({state:[{t:this.instance_15}]},2).to({state:[]},2).wait(58));
	this.timeline.addTween(cjs.Tween.get(this.instance_14).to({_off:true,regX:11,regY:11.1,scaleX:0.76,scaleY:0.76},30).wait(62));

	// M_Wash_Bubble
	this.instance_16 = new lib.M_Wash_Bubble_1();
	this.instance_16.parent = this;
	this.instance_16.setTransform(48.3,9,0.125,0.125,-155.3,0,0,11,10.5);
	this.instance_16.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get(this.instance_16).to({regY:11,scaleX:0.76,scaleY:0.76,x:48.4,y:8.9},24).wait(2).to({_off:true},2).wait(64));

	// M_Wash_Bubble
	this.instance_17 = new lib.M_Wash_Bubble_1();
	this.instance_17.parent = this;
	this.instance_17.setTransform(32.6,-16.6,0.076,0.076,-155.3,0,0,10.8,11);
	this.instance_17.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get(this.instance_17).to({regX:11,regY:11.1,scaleX:0.76,scaleY:0.76,y:-16.7},20).wait(2).to({_off:true},2).wait(68));

	// M_Wash_Bubble
	this.instance_18 = new lib.M_Wash_Bubble_1();
	this.instance_18.parent = this;
	this.instance_18.setTransform(35.5,5.1,0.103,0.103,-155.3,0,0,10.3,10.8);
	this.instance_18.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get(this.instance_18).to({regX:11,regY:11.1,scaleX:0.76,scaleY:0.76,x:32.6,y:7.6},22).wait(2).to({regY:11,x:35.5,y:5.1},0).to({_off:true},2).wait(66));

	// M_Wash_Bubble
	this.instance_19 = new lib.M_Wash_Bubble_1();
	this.instance_19.parent = this;
	this.instance_19.setTransform(56,0.3,0.124,0.124,-155.3,0,0,10.5,11.2);
	this.instance_19.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_20 = new lib.M_Wash_Bubble_pop_1();
	this.instance_20.parent = this;
	this.instance_20.setTransform(52,-4.5,0.686,0.686,-155.4,0,0,10.3,11.2);
	this.instance_20.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_19}]}).to({state:[{t:this.instance_19}]},24).to({state:[{t:this.instance_20}]},2).to({state:[]},2).wait(64));
	this.timeline.addTween(cjs.Tween.get(this.instance_19).to({regX:10.3,scaleX:0.69,scaleY:0.69,rotation:-155.4,x:52,y:-4.5},24).to({_off:true},2).wait(66));

	// M_Wash_Bubble
	this.instance_21 = new lib.M_Wash_Bubble_1();
	this.instance_21.parent = this;
	this.instance_21.setTransform(52.4,20,0.067,0.067,-155.3,0,0,11.8,11.1);
	this.instance_21.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_22 = new lib.M_Wash_Bubble_pop_1();
	this.instance_22.parent = this;
	this.instance_22.setTransform(52.4,19.8,0.757,0.757,-155.3,0,0,11.2,11.2);
	this.instance_22.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_21}]}).to({state:[{t:this.instance_21}]},22).to({state:[{t:this.instance_22}]},8).to({state:[{t:this.instance_22}]},2).to({state:[]},2).wait(58));
	this.timeline.addTween(cjs.Tween.get(this.instance_21).to({regX:11.7,regY:11.2,scaleX:0.53,scaleY:0.53,rotation:-155.4,x:46.9,y:21.6},22).to({_off:true,regX:11.2,scaleX:0.76,scaleY:0.76,rotation:-155.3,x:52.4,y:19.8},8).wait(62));

	// M_Wash_Bubble
	this.instance_23 = new lib.M_Wash_Bubble_1();
	this.instance_23.parent = this;
	this.instance_23.setTransform(38.5,-8.5,0.4,0.4,0,0,0,11,11);
	this.instance_23.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_24 = new lib.M_Wash_Bubble_pop_1();
	this.instance_24.parent = this;
	this.instance_24.setTransform(38.5,-8.5,1,1,0,0,0,11,11);
	this.instance_24.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_23}]}).to({state:[{t:this.instance_23}]},38).to({state:[{t:this.instance_24}]},2).to({state:[]},2).wait(50));
	this.timeline.addTween(cjs.Tween.get(this.instance_23).to({scaleX:1,scaleY:1},38).to({_off:true},2).wait(52));

	// M_Wash_Bubble
	this.instance_25 = new lib.M_Wash_Bubble_1();
	this.instance_25.parent = this;
	this.instance_25.setTransform(44,-14,0.413,0.413,0,0,0,11,11);
	this.instance_25.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_26 = new lib.M_Wash_Bubble_pop_1();
	this.instance_26.parent = this;
	this.instance_26.setTransform(44,-14,1,1,0,0,0,11,11);
	this.instance_26.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_25}]}).to({state:[{t:this.instance_25}]},40).to({state:[{t:this.instance_26}]},2).to({state:[]},2).wait(48));
	this.timeline.addTween(cjs.Tween.get(this.instance_25).to({scaleX:1,scaleY:1},40).to({_off:true},2).wait(50));

	// M_Wash_Bubble
	this.instance_27 = new lib.M_Wash_Bubble_1();
	this.instance_27.parent = this;
	this.instance_27.setTransform(28.7,0,0.379,0.379,0,0,0,11,11);
	this.instance_27.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_28 = new lib.M_Wash_Bubble_pop_1();
	this.instance_28.parent = this;
	this.instance_28.setTransform(28.7,0,1,1,0,0,0,11,11);
	this.instance_28.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_27}]}).to({state:[{t:this.instance_27}]},34).to({state:[{t:this.instance_28}]},2).to({state:[]},2).wait(54));
	this.timeline.addTween(cjs.Tween.get(this.instance_27).to({scaleX:1,scaleY:1},34).to({_off:true},2).wait(56));

	// M_Wash_Bubble
	this.instance_29 = new lib.M_Wash_Bubble_1();
	this.instance_29.parent = this;
	this.instance_29.setTransform(74.5,6,0.263,0.263,0,0,0,11,11);
	this.instance_29.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_30 = new lib.M_Wash_Bubble_pop_1();
	this.instance_30.parent = this;
	this.instance_30.setTransform(74.5,6,1,1,0,0,0,11,11);
	this.instance_30.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_29}]}).to({state:[{t:this.instance_30}]},32).to({state:[{t:this.instance_30}]},2).to({state:[]},2).wait(56));
	this.timeline.addTween(cjs.Tween.get(this.instance_29).to({_off:true,scaleX:1,scaleY:1},32).wait(60));

	// M_Wash_Bubble
	this.instance_31 = new lib.M_Wash_Bubble_1();
	this.instance_31.parent = this;
	this.instance_31.setTransform(54.9,13.5,0.214,0.214,0,0,0,11,11.2);
	this.instance_31.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_32 = new lib.M_Wash_Bubble_pop_1();
	this.instance_32.parent = this;
	this.instance_32.setTransform(54.9,13.5,1,1,0,0,0,11,11);
	this.instance_32.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_31}]}).to({state:[{t:this.instance_32}]},36).to({state:[{t:this.instance_32}]},2).to({state:[]},2).wait(52));
	this.timeline.addTween(cjs.Tween.get(this.instance_31).to({_off:true,regY:11,scaleX:1,scaleY:1},36).wait(56));

	// M_Wash_Bubble
	this.instance_33 = new lib.M_Wash_Bubble_1();
	this.instance_33.parent = this;
	this.instance_33.setTransform(55,2.5,0.143,0.143,0,0,0,10.8,11.2);
	this.instance_33.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_34 = new lib.M_Wash_Bubble_pop_1();
	this.instance_34.parent = this;
	this.instance_34.setTransform(55,2.5,1,1,0,0,0,11,11);
	this.instance_34.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_33}]}).to({state:[{t:this.instance_34}]},30).to({state:[{t:this.instance_34}]},2).to({state:[]},2).wait(58));
	this.timeline.addTween(cjs.Tween.get(this.instance_33).to({_off:true,regX:11,regY:11,scaleX:1,scaleY:1},30).wait(62));

	// M_Wash_Bubble
	this.instance_35 = new lib.M_Wash_Bubble_1();
	this.instance_35.parent = this;
	this.instance_35.setTransform(54.9,24.5,0.157,0.157,0,0,0,11.2,11.2);
	this.instance_35.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_36 = new lib.M_Wash_Bubble_pop_1();
	this.instance_36.parent = this;
	this.instance_36.setTransform(54.9,24.5,1,1,0,0,0,11,11);
	this.instance_36.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_35}]}).to({state:[{t:this.instance_36}]},32).to({state:[{t:this.instance_36}]},2).to({state:[]},2).wait(56));
	this.timeline.addTween(cjs.Tween.get(this.instance_35).to({_off:true,regX:11,regY:11,scaleX:1,scaleY:1},32).wait(60));

	// M_Wash_Bubble
	this.instance_37 = new lib.M_Wash_Bubble_1();
	this.instance_37.parent = this;
	this.instance_37.setTransform(36,24.5,0.357,0.357,0,0,0,10.2,11.1);
	this.instance_37.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_38 = new lib.M_Wash_Bubble_pop_1();
	this.instance_38.parent = this;
	this.instance_38.setTransform(36,24.5,1,1,0,0,0,11,11);
	this.instance_38.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_37}]}).to({state:[{t:this.instance_38}]},30).to({state:[{t:this.instance_38}]},2).to({state:[]},2).wait(58));
	this.timeline.addTween(cjs.Tween.get(this.instance_37).to({_off:true,regX:11,regY:11,scaleX:1,scaleY:1},30).wait(62));

	// M_Wash_Bubble
	this.instance_39 = new lib.M_Wash_Bubble_1();
	this.instance_39.parent = this;
	this.instance_39.setTransform(22,13.5,0.165,0.165,0,0,0,10.9,11);
	this.instance_39.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get(this.instance_39).to({regY:10.9,scaleX:0.91,scaleY:0.91,x:18.6,y:13.3},22).to({regX:11,regY:11,scaleX:1,scaleY:1,x:22,y:13.5},2).wait(2).to({_off:true},2).wait(64));

	// M_Wash_Bubble
	this.instance_40 = new lib.M_Wash_Bubble_1();
	this.instance_40.parent = this;
	this.instance_40.setTransform(39.7,11,0.136,0.136,0,0,0,11.1,11.1);
	this.instance_40.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get(this.instance_40).to({regX:11,regY:11,scaleX:1,scaleY:1},22).wait(2).to({_off:true},2).wait(66));

	// M_Wash_Bubble
	this.instance_41 = new lib.M_Wash_Bubble_1();
	this.instance_41.parent = this;
	this.instance_41.setTransform(17.7,28,0.164,0.164,0,0,0,10.7,11);
	this.instance_41.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get(this.instance_41).to({regX:11,scaleX:1,scaleY:1},24).wait(2).to({_off:true},2).wait(64));

	// M_Wash_Bubble
	this.instance_42 = new lib.M_Wash_Bubble_1();
	this.instance_42.parent = this;
	this.instance_42.setTransform(11,2.5,0.088,0.088,0,0,0,10.8,10.8);
	this.instance_42.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_43 = new lib.M_Wash_Bubble_pop_1();
	this.instance_43.parent = this;
	this.instance_43.setTransform(11,2.5,1,1,0,0,0,11,11);
	this.instance_43.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_42}]}).to({state:[{t:this.instance_43}]},30).to({state:[{t:this.instance_43}]},2).to({state:[]},2).wait(58));
	this.timeline.addTween(cjs.Tween.get(this.instance_42).to({_off:true,regX:11,regY:11,scaleX:1,scaleY:1},30).wait(62));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-11.2,-37.9,114.4,94.8);


(lib.CrocodileTorso_bubbles = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{wash:0,wash_stop:59});

	// Layer 5
	this.instance = new lib.Bubbles_together();
	this.instance.parent = this;
	this.instance.setTransform(-47,-33.8,1.051,1.051,0,131.5,131.4,35.6,10.9);

	this.instance_1 = new lib.Bubbles_together();
	this.instance_1.parent = this;
	this.instance_1.setTransform(-7.4,-20.2,1.051,1.051,0,6,6,35.1,11.2);

	this.instance_2 = new lib.Bubbles_together();
	this.instance_2.parent = this;
	this.instance_2.setTransform(31.3,-25.1,1.051,1.051,0,-178.7,-178.8,35.9,5.3);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[]}).to({state:[{t:this.instance_2},{t:this.instance_1},{t:this.instance}]},1).to({state:[]},58).wait(1));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = null;


(lib.CrocodileTorso = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{dirty:0,dirty_stop:1,clean:2,clean_loop:3,glow:4,glow_loop:5,"wash":6,"wash_stop":64,glowclean:90,glowclean_loop:91,"final":92,final_loop:93});

	// Crocodile Torso0001.png
	this.instance = new lib.CrocodileTorso0002();
	this.instance.parent = this;
	this.instance.setTransform(-106.5,-43.4,0.5,0.5);

	this.instance_1 = new lib.left_over_bubbles_sparse();
	this.instance_1.parent = this;
	this.instance_1.setTransform(-68.1,-23.8,1,1,0,0,0,47.6,10.1);

	this.instance_2 = new lib.left_over_bubbles_few();
	this.instance_2.parent = this;
	this.instance_2.setTransform(35.3,-26.1,1,1,0,0,0,47.8,9.3);

	this.instance_3 = new lib.left_over_bubbles();
	this.instance_3.parent = this;
	this.instance_3.setTransform(-14.2,-24.6,1,1,0,0,0,50.6,5.2);

	this.instance_4 = new lib.CrocodileTorso0001();
	this.instance_4.parent = this;
	this.instance_4.setTransform(-106.5,-43.4,0.5,0.5);

	this.instance_5 = new lib.croc_backGlow();
	this.instance_5.parent = this;
	this.instance_5.setTransform(-13.5,-18.5,1.25,1.25,0,0,180,87.5,16.4);

	this.glow = new lib.blueglowback();
	this.glow.parent = this;
	this.glow.setTransform(-13.5,-18.5,1.25,1.25,0,0,180,87.5,16.4);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_4},{t:this.instance_3},{t:this.instance_2},{t:this.instance_1}]},2).to({state:[{t:this.instance},{t:this.instance_5}]},2).to({state:[{t:this.instance_4}]},2).to({state:[{t:this.instance_4},{t:this.instance_3},{t:this.instance_2},{t:this.instance_1}]},7).to({state:[{t:this.instance_4},{t:this.instance_3},{t:this.instance_2},{t:this.instance_1}]},51).to({state:[]},1).to({state:[{t:this.instance_4},{t:this.instance_3},{t:this.instance_2},{t:this.instance_1},{t:this.glow}]},25).to({state:[{t:this.instance_4}]},2).to({state:[]},2).wait(162));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-106.6,-45.9,217.1,90.5);


(lib.CrocodileTail_bubbles = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{"wash":0,"wash_stop":105});

	// Layer 5
	this.instance = new lib.Bubbles_together();
	this.instance.parent = this;
	this.instance.setTransform(13.5,-12.3,0.715,0.684,0,149,151.1,35.6,10.9);

	this.instance_1 = new lib.Bubbles_together();
	this.instance_1.parent = this;
	this.instance_1.setTransform(130,-33.6,0.715,0.684,0,149,151.1,35.5,10.8);

	this.instance_2 = new lib.Bubbles_together();
	this.instance_2.parent = this;
	this.instance_2.setTransform(57.7,1.9,0.715,0.684,0,149,151.1,35.5,10.8);

	this.instance_3 = new lib.Bubbles_together();
	this.instance_3.parent = this;
	this.instance_3.setTransform(91.5,-3.5,0.715,0.684,0,149,151.1,35.5,10.8);

	this.instance_4 = new lib.Bubbles_together();
	this.instance_4.parent = this;
	this.instance_4.setTransform(130.2,0.6,0.719,0.681,0,3.8,2.3,35.7,10.8);

	this.instance_5 = new lib.Bubbles_together();
	this.instance_5.parent = this;
	this.instance_5.setTransform(2.8,2.7,0.719,0.68,0,-176.7,-178.2,35.8,10.8);

	this.instance_6 = new lib.Bubbles_together();
	this.instance_6.parent = this;
	this.instance_6.setTransform(-27.4,14.7,0.572,0.547,0,-167.5,-169.9,34.9,10.6);

	this.instance_7 = new lib.Bubbles_together();
	this.instance_7.parent = this;
	this.instance_7.setTransform(78.7,-23.1,0.715,0.684,0,149,151.1,35.7,10.9);

	this.instance_8 = new lib.Bubbles_together();
	this.instance_8.parent = this;
	this.instance_8.setTransform(24.1,-4.1,0.715,0.684,0,149,151.1,35.6,10.7);

	this.instance_9 = new lib.Bubbles_together();
	this.instance_9.parent = this;
	this.instance_9.setTransform(-75.5,9.8,0.72,0.72,0,80.1,80,35.2,11.5);

	this.instance_10 = new lib.Bubbles_together();
	this.instance_10.parent = this;
	this.instance_10.setTransform(-9.7,27.3,0.72,0.72,0,12.3,12.2,35.8,11.2);

	this.instance_11 = new lib.Bubbles_together();
	this.instance_11.parent = this;
	this.instance_11.setTransform(-135.7,7.6,0.72,0.72,0,-168.2,-168.3,35.7,10.9);

	this.instance_12 = new lib.Bubbles_together();
	this.instance_12.parent = this;
	this.instance_12.setTransform(-167.9,14.6,0.576,0.576,0,-159.5,-159.6,35.6,11);

	this.instance_13 = new lib.Bubbles_together();
	this.instance_13.parent = this;
	this.instance_13.setTransform(-36.1,0.4,0.72,0.72,0,36.8,36.7,37.8,8.3);

	this.instance_14 = new lib.Bubbles_together();
	this.instance_14.parent = this;
	this.instance_14.setTransform(-101.1,11.2,0.72,0.72,0,-107.9,-108,34.7,10.6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[]}).to({state:[{t:this.instance_14},{t:this.instance_13},{t:this.instance_12},{t:this.instance_11},{t:this.instance_10},{t:this.instance_9},{t:this.instance_8},{t:this.instance_7},{t:this.instance_6},{t:this.instance_5},{t:this.instance_4},{t:this.instance_3},{t:this.instance_2},{t:this.instance_1},{t:this.instance}]},1).to({state:[]},104).wait(99));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = null;


(lib.CrocodileTail = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{"dirty":0,"dirty_stop":1,"clean":2,clean_stop:3,"glow":4,glow_stop:5,"wash":6,"wash_stop":150,"glowclean":151,"glowclean_loop":152,"final":153,"final_loop":154});

	// Crocodile Tail0001.png
	this.instance = new lib.CrocodileTail0002();
	this.instance.parent = this;
	this.instance.setTransform(-185.2,-41.4,0.5,0.5);

	this.instance_1 = new lib.left_over_bubbles_2();
	this.instance_1.parent = this;
	this.instance_1.setTransform(-60.1,7.5,0.5,0.5,0,0,0,48.9,4.8);

	this.instance_2 = new lib.left_over_bubbles();
	this.instance_2.parent = this;
	this.instance_2.setTransform(-93.4,7.1,0.5,0.5,0,0,0,50.6,5.3);

	this.instance_3 = new lib.left_over_bubbles_sparse();
	this.instance_3.parent = this;
	this.instance_3.setTransform(-13,1.1,1,1,0,0,0,47.6,10.1);

	this.instance_4 = new lib.left_over_bubbles_few();
	this.instance_4.parent = this;
	this.instance_4.setTransform(15.7,1.9,1,1,0,0,0,47.8,9.3);

	this.instance_5 = new lib.left_over_bubbles_2();
	this.instance_5.parent = this;
	this.instance_5.setTransform(60.6,-10.7,1,1,0,0,0,48.9,4.8);

	this.instance_6 = new lib.left_over_bubbles();
	this.instance_6.parent = this;
	this.instance_6.setTransform(104.5,-14.3,1,1,0,0,0,50.6,5.2);

	this.instance_7 = new lib.CrocodileTail0001();
	this.instance_7.parent = this;
	this.instance_7.setTransform(-185.2,-41.4,0.5,0.5);

	this.instance_8 = new lib.croc_tailGlow();
	this.instance_8.parent = this;
	this.instance_8.setTransform(-13.8,0.1,1.3,1.25,0,-2.2,177.8,132.8,27);

	this.glow = new lib.blueglowtail();
	this.glow.parent = this;
	this.glow.setTransform(-13.8,0.1,1.3,1.25,0,-2.2,177.8,132.8,27);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_7},{t:this.instance_6},{t:this.instance_5},{t:this.instance_4},{t:this.instance_3},{t:this.instance_2},{t:this.instance_1}]},2).to({state:[{t:this.instance},{t:this.instance_8}]},2).to({state:[{t:this.instance_7}]},2).to({state:[{t:this.instance_7},{t:this.instance_6},{t:this.instance_5},{t:this.instance_4},{t:this.instance_3},{t:this.instance_2},{t:this.instance_1}]},8).to({state:[{t:this.instance_7},{t:this.instance_6},{t:this.instance_5},{t:this.instance_4},{t:this.instance_3},{t:this.instance_2},{t:this.instance_1}]},136).to({state:[{t:this.instance_7},{t:this.instance_6},{t:this.instance_5},{t:this.instance_4},{t:this.instance_3},{t:this.instance_2},{t:this.instance_1},{t:this.glow}]},1).to({state:[{t:this.instance_7}]},2).to({state:[]},2).wait(151));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-186,-41.4,360.8,86);


(lib.CrocodileHead_001 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{"dirty":0,"dirty_stop":1,"clean":2,"clean_loop":3,"glow":4,"glow_loop":5,"wash":6,"wash_stop":59,"glowclean":60,"glowclean_loop":61,"final":62,"final_loop":63});

	// Eye
	this.instance = new lib.CrocodileHead_0010002();
	this.instance.parent = this;
	this.instance.setTransform(-44.8,-25,0.5,0.5);

	this.instance_1 = new lib.left_over_bubbles_sparse();
	this.instance_1.parent = this;
	this.instance_1.setTransform(29.5,-7.5,0.5,0.5,0,0,0,47.7,10.1);

	this.instance_2 = new lib.left_over_bubbles();
	this.instance_2.parent = this;
	this.instance_2.setTransform(8.6,1.3,0.5,0.5,-15,0,0,50.6,5.2);

	this.instance_3 = new lib.CrocodileHead_0010001();
	this.instance_3.parent = this;
	this.instance_3.setTransform(-44.8,-25,0.5,0.5);

	this.instance_4 = new lib.croc_mouthGlow();
	this.instance_4.parent = this;
	this.instance_4.setTransform(6.6,5.5,1.246,0.999,0,-29.8,150.2,32.3,12.1);

	this.glow = new lib.blueglowmouth();
	this.glow.parent = this;
	this.glow.setTransform(6.6,5.5,1.246,0.999,0,-29.8,150.2,32.3,12.1);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_3},{t:this.instance_2},{t:this.instance_1}]},2).to({state:[{t:this.instance},{t:this.instance_4}]},2).to({state:[{t:this.instance_3}]},2).to({state:[{t:this.instance_3},{t:this.instance_2},{t:this.instance_1}]},7).to({state:[{t:this.instance_3},{t:this.instance_2},{t:this.instance_1}]},46).to({state:[{t:this.instance_3},{t:this.instance_2},{t:this.instance_1},{t:this.glow}]},1).to({state:[{t:this.instance_3}]},2).to({state:[]},2).wait(142));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-44.8,-30.7,98,75.7);


(lib.CrocLowerHindLeg_bubbles = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{"wash":0,"wash_stop":79});

	// Layer 2
	this.instance = new lib.Bubbles_together();
	this.instance.parent = this;
	this.instance.setTransform(159.5,52.2,0.72,0.72,0,19.1,19,35.7,11);

	this.instance_1 = new lib.Bubbles_together();
	this.instance_1.parent = this;
	this.instance_1.setTransform(19.2,48,0.72,0.72,0,19.1,19,35.6,10.8);

	this.instance_2 = new lib.Bubbles_together();
	this.instance_2.parent = this;
	this.instance_2.setTransform(51.4,54.1,0.72,0.72,0,-165.7,-165.8,35.6,10.7);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[]}).to({state:[{t:this.instance_2},{t:this.instance_1},{t:this.instance}]},1).to({state:[]},78).wait(33));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = null;


(lib.CrocLowerHindLeg = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{"dirty":0,"dirty_stop":1,"clean":2,"clean_stop":3,"glow":4,"glow_stop":5,"wash":6,"wash_stop":155,"glowclean":156,"glowclean_loop":157,"final":158,"final_loop":159});

	// Croc Lower Hind Leg0001.png
	this.instance = new lib.CrocLowerHindLeg0002();
	this.instance.parent = this;
	this.instance.setTransform(-1.7,1,0.5,0.5);

	this.instance_1 = new lib.left_over_bubbles();
	this.instance_1.parent = this;
	this.instance_1.setTransform(40.4,51.8,0.75,0.75,0,0,180,50.6,5.2);

	this.instance_2 = new lib.CrocLowerHindLeg0001();
	this.instance_2.parent = this;
	this.instance_2.setTransform(-1.7,1,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_2},{t:this.instance_1}]},2).to({state:[{t:this.instance}]},2).to({state:[{t:this.instance_2}]},2).to({state:[{t:this.instance_2},{t:this.instance_1}]},34).to({state:[{t:this.instance_2}]},118).to({state:[]},2).wait(1));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-1.7,1,82,70);


(lib.CrocFrontLeg = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{"dirty":0,"dirty_stop":1,"clean":2,"clean_stop":3,"glow":4,"glow_stop":5,"wash":6,"wash_stop":60,"glowclean":61,"glowclean_loop":62,"final":63,"final_loop":64});

	// Croc Front Leg0001.png
	this.instance = new lib.CrocFrontLeg0002();
	this.instance.parent = this;
	this.instance.setTransform(-30.9,-25.5,0.5,0.5);

	this.instance_1 = new lib.left_over_bubbles_2();
	this.instance_1.parent = this;
	this.instance_1.setTransform(12.8,13.7,1,1,0,0,0,48.9,4.8);

	this.instance_2 = new lib.CrocFrontLeg0001();
	this.instance_2.parent = this;
	this.instance_2.setTransform(-30.9,-25.5,0.5,0.5);

	this.glow = new lib.bluefootglow();
	this.glow.parent = this;
	this.glow.setTransform(-59.6,9.8,1.3,1.3,0,0,180,-16.1,6.5);

	this.instance_3 = new lib.left_over_bubbles_2();
	this.instance_3.parent = this;
	this.instance_3.setTransform(12.8,13.7,1,1,0,0,0,48.9,4.8);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_2,p:{x:-30.9,y:-25.5}},{t:this.instance_1}]},2).to({state:[{t:this.instance}]},2).to({state:[{t:this.instance_2,p:{x:-30.9,y:-25.5}}]},2).to({state:[{t:this.instance_2,p:{x:-30.9,y:-25.5}},{t:this.instance_1}]},8).to({state:[{t:this.instance_2,p:{x:-30.9,y:-25.5}},{t:this.instance_1}]},46).to({state:[{t:this.instance_3},{t:this.instance_2,p:{x:-31,y:-26}},{t:this.instance_1},{t:this.glow}]},1).to({state:[{t:this.instance_1},{t:this.instance_2,p:{x:-31,y:-26}}]},2).wait(162));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-30.9,-25.5,91.6,56.1);


(lib.water_drops_018 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 2
	this.instance = new lib.Running_drop();
	this.instance.parent = this;
	this.instance.setTransform(387.4,33,0.486,0.486,0,0,180,4.7,10.1);
	this.instance._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1).to({_off:false},0).to({_off:true},28).wait(4));

	// Layer 1
	this.instance_1 = new lib.Running_drop();
	this.instance_1.parent = this;
	this.instance_1.setTransform(174.5,27.3,0.486,0.486,0,0,180,4.7,10.1);
	this.instance_1._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance_1).wait(7).to({_off:false},0).to({_off:true},24).wait(2));

	// WET DROPS
	this.instance_2 = new lib.Running_drop();
	this.instance_2.parent = this;
	this.instance_2.setTransform(70,37,0.486,0.486,0,0,180,4.8,10.1);
	this.instance_2._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance_2).wait(4).to({_off:false},0).to({_off:true},24).wait(5));

	// WET DROPS
	this.instance_3 = new lib.Running_drop();
	this.instance_3.parent = this;
	this.instance_3.setTransform(-128.1,71.3,0.486,0.486,0,0,180,4.8,10.1);
	this.instance_3._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance_3).wait(1).to({_off:false},0).to({_off:true},24).wait(8));

	// WET DROPS
	this.instance_4 = new lib.Running_drop();
	this.instance_4.parent = this;
	this.instance_4.setTransform(-16.3,64,0.486,0.486,0,0,0,4.7,10.1);
	this.instance_4._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance_4).wait(6).to({_off:false},0).to({_off:true},24).wait(3));

	// WET DROPS
	this.instance_5 = new lib.Running_drop();
	this.instance_5.parent = this;
	this.instance_5.setTransform(283.6,41.2,0.486,0.486,0,0,0,4.8,10.1);

	this.instance_6 = new lib.Running_drop();
	this.instance_6.parent = this;
	this.instance_6.setTransform(20.8,54.3,0.486,0.486,0,0,0,4.7,10.1);

	this.instance_7 = new lib.Running_drop();
	this.instance_7.parent = this;
	this.instance_7.setTransform(329.5,42.7,0.486,0.486,0,0,0,4.8,10.1);

	this.instance_8 = new lib.Running_drop();
	this.instance_8.parent = this;
	this.instance_8.setTransform(214.7,22.3,0.486,0.486,0,0,0,4.8,10.1);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[]}).to({state:[{t:this.instance_8},{t:this.instance_7},{t:this.instance_6},{t:this.instance_5}]},3).to({state:[]},24).wait(6));

	// WET DROPS
	this.instance_9 = new lib.Running_drop();
	this.instance_9.parent = this;
	this.instance_9.setTransform(132.4,46.7,0.486,0.486,0,0,0,4.8,10.1);

	this.timeline.addTween(cjs.Tween.get(this.instance_9).to({_off:true},24).wait(9));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(125.1,36.8,18,24);


(lib.croc_mouthMud_001_bubbles = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{mud:0,soap:44,"clean":50});

	// timeline functions:
	this.frame_0 = function() {
		/* stop();*/
	}
	this.frame_44 = function() {
		/* stop();*/
	}
	this.frame_50 = function() {
		/* stop();*/
	}

	// actions tween:
	this.timeline.addTween(cjs.Tween.get(this).call(this.frame_0).wait(44).call(this.frame_44).wait(6).call(this.frame_50).wait(6));

	// Layer 5
	this.instance = new lib.Bubbles_together();
	this.instance.parent = this;
	this.instance.setTransform(16.1,28.4,0.72,0.72,0,-15.9,-16,35.6,10.9);

	this.instance_1 = new lib.Bubbles_together();
	this.instance_1.parent = this;
	this.instance_1.setTransform(49.5,12.7,0.72,0.72,0,159.3,159.2,35.6,10.8);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[]}).to({state:[{t:this.instance_1},{t:this.instance}]},1).to({state:[]},43).wait(12));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = null;


(lib.CrocUpperJaw_bubbles = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 2
	this.instance = new lib.croc_mouthMud_001_bubbles();
	this.instance.parent = this;
	this.instance.setTransform(10.4,2.1,1,1,0,0,0,32.2,20.4);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.CrocUpperJaw_bubbles, null, null);


(lib.CrocodileHead_001_bubbles = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{"wash":0,"wash_stop":50});

	// Croc Upper Jaw
	this.instance = new lib.CrocUpperJaw_bubbles();
	this.instance.parent = this;
	this.instance.setTransform(-36.6,3.4,1,1,0,0,0,-36.6,3.4);
	this.instance.shadow = new cjs.Shadow("rgba(0,0,0,1)",0,1,3);

	this.instance_1 = new lib.Bubbles_together();
	this.instance_1.parent = this;
	this.instance_1.setTransform(-9.4,7.7,0.72,0.72,0,-15.9,-16,35.6,10.8);

	this.instance_2 = new lib.Bubbles_together();
	this.instance_2.parent = this;
	this.instance_2.setTransform(23.9,-7.9,0.72,0.72,0,159.3,159.2,35.7,10.8);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_2},{t:this.instance_1}]},1).to({state:[]},49).wait(43));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-25.8,-22.3,12,12);


(lib.CrocodileHead_010 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{"dirty":0,"dirty_stop":1,"clean":2,"clean_loop":3,"glow":4,"glow_loop":5,"wash":6,"wash_stop":155,"glowclean":156,"glowclean_loop":157,"final":158,"final_loop":159});

	// bubbles
	this.instance = new lib.CrocodileHead_001_bubbles();
	this.instance.parent = this;
	this.instance.setTransform(100,-3,0.667,0.616,0,-23.5,156.5,-93.6,63.2);
	this.instance.shadow = new cjs.Shadow("rgba(0,0,0,1)",0,0,2);
	this.instance._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(6).to({_off:false},0).wait(36).to({regX:-24.1,regY:20.4,rotation:23.5,skewX:0,skewY:0,x:3.1,y:-3.7},0).to({_off:true},113).wait(6));

	// Eye
	this.instance_1 = new lib.CrocodileHead_0100002();
	this.instance_1.parent = this;
	this.instance_1.setTransform(-46.2,-43.3,0.5,0.5);

	this.instance_2 = new lib.left_over_bubbles_sparse();
	this.instance_2.parent = this;
	this.instance_2.setTransform(26.9,-29.2,0.5,0.5,-15,0,0,47.9,10);

	this.instance_3 = new lib.left_over_bubbles();
	this.instance_3.parent = this;
	this.instance_3.setTransform(8.9,-15.2,0.5,0.5,-30,0,0,50.6,5.2);

	this.instance_4 = new lib.CrocodileHead_0100001();
	this.instance_4.parent = this;
	this.instance_4.setTransform(-46.2,-43.3,0.5,0.5);

	this.instance_5 = new lib.croc_mouthGlow();
	this.instance_5.parent = this;
	this.instance_5.setTransform(4.6,-9.7,1.25,1,0,-38,142,32.4,12.1);

	this.glow = new lib.blueglowmouth();
	this.glow.parent = this;
	this.glow.setTransform(7.1,-16.7,1,1,0,-30,150,32.4,12);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_1}]}).to({state:[{t:this.instance_4},{t:this.instance_3},{t:this.instance_2}]},2).to({state:[{t:this.instance_1},{t:this.instance_5}]},2).to({state:[{t:this.instance_4}]},2).to({state:[{t:this.instance_4},{t:this.glow}]},150).to({state:[{t:this.instance_4}]},2).to({state:[]},2).wait(1));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-46.2,-43.3,104,89.4);


(lib.CrocodileHead_009 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{"dirty":0,"dirty_stop":1,"clean":2,"clean_loop":3,"glow":4,"glow_loop":5,"wash":6,"wash_stop":155,"glowclean":156,"glowclean_loop":157,"final":158,"final_loop":159});

	// bubbles
	this.instance = new lib.CrocodileHead_001_bubbles();
	this.instance.parent = this;
	this.instance.setTransform(100,-3,0.667,0.616,0,-23.5,156.5,-93.6,63.2);
	this.instance.shadow = new cjs.Shadow("rgba(0,0,0,1)",0,0,2);
	this.instance._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(6).to({_off:false},0).wait(36).to({regX:-24.1,regY:20.4,rotation:23.5,skewX:0,skewY:0,x:3.1,y:-3.7},0).to({_off:true},113).wait(6));

	// Eye
	this.instance_1 = new lib.CrocodileHead_0090002();
	this.instance_1.parent = this;
	this.instance_1.setTransform(-45.9,-41.2,0.5,0.5);

	this.instance_2 = new lib.left_over_bubbles_sparse();
	this.instance_2.parent = this;
	this.instance_2.setTransform(26.9,-27,0.5,0.5,-15,0,0,47.9,10);

	this.instance_3 = new lib.left_over_bubbles();
	this.instance_3.parent = this;
	this.instance_3.setTransform(8.9,-13,0.5,0.5,-30,0,0,50.5,5.2);

	this.instance_4 = new lib.CrocodileHead_0090001();
	this.instance_4.parent = this;
	this.instance_4.setTransform(-45.9,-41.2,0.5,0.5);

	this.instance_5 = new lib.croc_mouthGlow();
	this.instance_5.parent = this;
	this.instance_5.setTransform(5.1,-6.7,1.25,1,0,-38,142,32.4,12.1);

	this.glow = new lib.blueglowmouth();
	this.glow.parent = this;
	this.glow.setTransform(10.6,-16.5,1,1,0,-30,150,32.4,12);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_1}]}).to({state:[{t:this.instance_4},{t:this.instance_3},{t:this.instance_2}]},2).to({state:[{t:this.instance_1},{t:this.instance_5}]},2).to({state:[{t:this.instance_4}]},2).to({state:[{t:this.instance_4},{t:this.glow}]},150).to({state:[{t:this.instance_4}]},2).to({state:[]},2).wait(1));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-45.9,-41.2,103,86.8);


(lib.CrocodileHead_008 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{"dirty":0,"dirty_stop":1,"clean":2,"clean_loop":3,"glow":4,"glow_loop":5,"wash":6,"wash_stop":155,"glowclean":156,"glowclean_loop":157,"final":158,"final_loop":159});

	// bubbles
	this.instance = new lib.CrocodileHead_001_bubbles();
	this.instance.parent = this;
	this.instance.setTransform(100,-3,0.667,0.616,0,-23.5,156.5,-93.6,63.2);
	this.instance.shadow = new cjs.Shadow("rgba(0,0,0,1)",0,0,2);
	this.instance._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(6).to({_off:false},0).wait(36).to({regX:-24.1,regY:20.4,rotation:23.5,skewX:0,skewY:0,x:3.1,y:-3.7},0).to({_off:true},113).wait(6));

	// Eye
	this.instance_1 = new lib.CrocodileHead_0080002();
	this.instance_1.parent = this;
	this.instance_1.setTransform(-45.6,-39.4,0.5,0.5);

	this.instance_2 = new lib.left_over_bubbles_sparse();
	this.instance_2.parent = this;
	this.instance_2.setTransform(26.7,-26.6,0.5,0.5,-15.5,0,0,47.9,10.2);

	this.instance_3 = new lib.left_over_bubbles();
	this.instance_3.parent = this;
	this.instance_3.setTransform(8.9,-12.6,0.5,0.5,-30.5,0,0,50.6,5.2);

	this.instance_4 = new lib.CrocodileHead_0080001();
	this.instance_4.parent = this;
	this.instance_4.setTransform(-45.6,-39.4,0.5,0.5);

	this.instance_5 = new lib.croc_mouthGlow();
	this.instance_5.parent = this;
	this.instance_5.setTransform(4.1,-4.6,1.25,1,0,-38.7,141.3,32.4,12.1);

	this.glow = new lib.blueglowmouth();
	this.glow.parent = this;
	this.glow.setTransform(10.7,-15.3,1,1,0,-30.2,149.8,32.3,12.1);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_1}]}).to({state:[{t:this.instance_4},{t:this.instance_3},{t:this.instance_2}]},2).to({state:[{t:this.instance_1},{t:this.instance_5}]},2).to({state:[{t:this.instance_4}]},2).to({state:[{t:this.instance_4},{t:this.glow}]},150).to({state:[{t:this.instance_4}]},2).to({state:[]},2).wait(1));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-45.6,-39.4,103,84.6);


(lib.CrocodileHead_007 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{"dirty":0,"dirty_stop":1,"clean":2,"clean_loop":3,"glow":4,"glow_loop":5,"wash":6,"wash_stop":155,"glowclean":156,"glowclean_loop":157,"final":158,"final_loop":159});

	// bubbles
	this.instance = new lib.CrocodileHead_001_bubbles();
	this.instance.parent = this;
	this.instance.setTransform(100,-3,0.667,0.616,0,-23.5,156.5,-93.6,63.2);
	this.instance.shadow = new cjs.Shadow("rgba(0,0,0,1)",0,0,2);
	this.instance._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(6).to({_off:false},0).wait(36).to({regX:-24.1,regY:20.4,rotation:23.5,skewX:0,skewY:0,x:3.1,y:-3.7},0).to({_off:true},113).wait(6));

	// Eye
	this.instance_1 = new lib.CrocodileHead_0070002();
	this.instance_1.parent = this;
	this.instance_1.setTransform(-45.6,-37.4,0.5,0.5);

	this.instance_2 = new lib.left_over_bubbles_sparse();
	this.instance_2.parent = this;
	this.instance_2.setTransform(26.8,-22.4,0.5,0.5,-15,0,0,47.7,10.1);

	this.instance_3 = new lib.left_over_bubbles();
	this.instance_3.parent = this;
	this.instance_3.setTransform(8.9,-8.5,0.5,0.5,-30,0,0,50.6,5.2);

	this.instance_4 = new lib.CrocodileHead_0070001();
	this.instance_4.parent = this;
	this.instance_4.setTransform(-45.6,-37.4,0.5,0.5);

	this.instance_5 = new lib.croc_mouthGlow();
	this.instance_5.parent = this;
	this.instance_5.setTransform(6.1,-6.6,1.25,1,0,-30,150,32.4,12.1);

	this.glow = new lib.blueglowmouth();
	this.glow.parent = this;
	this.glow.setTransform(8.1,-12.7,1,1,0,-25.2,154.8,32.3,12.1);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_1}]}).to({state:[{t:this.instance_4},{t:this.instance_3},{t:this.instance_2}]},2).to({state:[{t:this.instance_1},{t:this.instance_5}]},2).to({state:[{t:this.instance_4}]},2).to({state:[{t:this.instance_4},{t:this.glow}]},150).to({state:[{t:this.instance_4}]},2).to({state:[]},2).wait(1));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-45.6,-37.4,102,82.1);


(lib.CrocodileHead_006 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{"dirty":0,"dirty_stop":1,"clean":2,"clean_loop":3,"glow":4,"glow_loop":5,"wash":6,"wash_stop":155,"glowclean":156,"glowclean_loop":157,"final":158,"final_loop":159});

	// bubbles
	this.instance = new lib.CrocodileHead_001_bubbles();
	this.instance.parent = this;
	this.instance.setTransform(100,-3,0.667,0.616,0,-23.5,156.5,-93.6,63.2);
	this.instance.shadow = new cjs.Shadow("rgba(0,0,0,1)",0,0,2);
	this.instance._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(6).to({_off:false},0).wait(36).to({regX:-24.1,regY:20.4,rotation:23.5,skewX:0,skewY:0,x:3.1,y:-3.7},0).to({_off:true},113).wait(6));

	// Crocodile Head_0060001.png
	this.instance_1 = new lib.CrocodileHead_0060002();
	this.instance_1.parent = this;
	this.instance_1.setTransform(-45.6,-35.3,0.5,0.5);

	this.instance_2 = new lib.left_over_bubbles_sparse();
	this.instance_2.parent = this;
	this.instance_2.setTransform(28,-19.9,0.5,0.5,-9,0,0,47.8,10.1);

	this.instance_3 = new lib.left_over_bubbles();
	this.instance_3.parent = this;
	this.instance_3.setTransform(8.8,-7.9,0.5,0.5,-24,0,0,50.6,5.2);

	this.instance_4 = new lib.CrocodileHead_0060001();
	this.instance_4.parent = this;
	this.instance_4.setTransform(-45.6,-35.3,0.5,0.5);

	this.instance_5 = new lib.croc_mouthGlow();
	this.instance_5.parent = this;
	this.instance_5.setTransform(5.4,-4.6,1.25,1,0,-30,150,32.4,12);

	this.glow = new lib.blueglowmouth();
	this.glow.parent = this;
	this.glow.setTransform(8.7,-9.5,1,1,0,-27,153,32.3,12);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_1}]}).to({state:[{t:this.instance_4},{t:this.instance_3},{t:this.instance_2}]},2).to({state:[{t:this.instance_1},{t:this.instance_5}]},2).to({state:[{t:this.instance_4}]},2).to({state:[{t:this.instance_4},{t:this.glow}]},150).to({state:[{t:this.instance_4}]},2).to({state:[]},2).wait(1));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-45.6,-35.3,101,79);


(lib.CrocodileHead_005 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{"dirty":0,"dirty_stop":1,"clean":2,"clean_loop":3,"glow":4,"glow_loop":5,"wash":6,"wash_stop":155,"glowclean":156,"glowclean_loop":157,"final":158,"final_loop":159});

	// bubbles
	this.instance = new lib.CrocodileHead_001_bubbles();
	this.instance.parent = this;
	this.instance.setTransform(100,-3,0.667,0.616,0,-23.5,156.5,-93.6,63.2);
	this.instance.shadow = new cjs.Shadow("rgba(0,0,0,1)",0,0,2);
	this.instance._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(6).to({_off:false},0).wait(36).to({regX:-24.1,regY:20.4,rotation:23.5,skewX:0,skewY:0,x:3.1,y:-3.7},0).to({_off:true},113).wait(6));

	// Eye
	this.instance_1 = new lib.CrocodileHead_0050002();
	this.instance_1.parent = this;
	this.instance_1.setTransform(-45.3,-33.3,0.5,0.5);

	this.instance_2 = new lib.left_over_bubbles_sparse();
	this.instance_2.parent = this;
	this.instance_2.setTransform(33,-18,0.5,0.5,0,0,0,47.7,10.1);

	this.instance_3 = new lib.left_over_bubbles();
	this.instance_3.parent = this;
	this.instance_3.setTransform(12.1,-9.2,0.5,0.5,-15,0,0,50.6,5.2);

	this.instance_4 = new lib.CrocodileHead_0050001();
	this.instance_4.parent = this;
	this.instance_4.setTransform(-45.3,-33.3,0.5,0.5);

	this.instance_5 = new lib.croc_mouthGlow();
	this.instance_5.parent = this;
	this.instance_5.setTransform(5.2,-2.5,1.25,1,0,-30,150,32.4,12.1);

	this.glow = new lib.blueglowmouth();
	this.glow.parent = this;
	this.glow.setTransform(10.6,-7.8,1,1,0,-25,155,32.3,12);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_1}]}).to({state:[{t:this.instance_4},{t:this.instance_3},{t:this.instance_2}]},2).to({state:[{t:this.instance_1},{t:this.instance_5}]},2).to({state:[{t:this.instance_4}]},2).to({state:[{t:this.instance_4},{t:this.glow}]},150).to({state:[{t:this.instance_4}]},2).to({state:[]},2).wait(1));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-45.3,-33.3,101,77);


(lib.CrocodileHead_004 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{"dirty":0,"dirty_stop":1,"clean":2,"clean_loop":3,"glow":4,"glow_loop":5,"wash":6,"wash_stop":155,"glowclean":156,"glowclean_loop":157,"final":158,"final_loop":159});

	// bubbles
	this.instance = new lib.CrocodileHead_001_bubbles();
	this.instance.parent = this;
	this.instance.setTransform(100,-3,0.667,0.616,0,-23.5,156.5,-93.6,63.2);
	this.instance.shadow = new cjs.Shadow("rgba(0,0,0,1)",0,0,2);
	this.instance._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(6).to({_off:false},0).wait(36).to({regX:-24.1,regY:20.4,rotation:23.5,skewX:0,skewY:0,x:3.1,y:-3.7},0).to({_off:true},113).wait(6));

	// Eye
	this.instance_1 = new lib.CrocodileHead_0040002();
	this.instance_1.parent = this;
	this.instance_1.setTransform(-45,-31.2,0.5,0.5);

	this.instance_2 = new lib.left_over_bubbles_sparse();
	this.instance_2.parent = this;
	this.instance_2.setTransform(32.3,-16.5,0.5,0.5,0,0,0,47.7,10.1);

	this.instance_3 = new lib.left_over_bubbles();
	this.instance_3.parent = this;
	this.instance_3.setTransform(11.4,-7.7,0.5,0.5,-15,0,0,50.6,5.2);

	this.instance_4 = new lib.CrocodileHead_0040001();
	this.instance_4.parent = this;
	this.instance_4.setTransform(-45,-31.2,0.5,0.5);

	this.instance_5 = new lib.croc_mouthGlow();
	this.instance_5.parent = this;
	this.instance_5.setTransform(6.5,-0.8,1.251,0.999,0,-29.9,150.1,32.2,12);

	this.glow = new lib.blueglowmouth();
	this.glow.parent = this;
	this.glow.setTransform(10.7,-8,1,1,0,-20.5,159.5,32.3,12.1);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_1}]}).to({state:[{t:this.instance_4},{t:this.instance_3},{t:this.instance_2}]},2).to({state:[{t:this.instance_1},{t:this.instance_5}]},2).to({state:[{t:this.instance_4}]},2).to({state:[{t:this.instance_4},{t:this.glow}]},150).to({state:[{t:this.instance_4}]},2).to({state:[]},2).wait(1));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-45,-31.2,99,75);


(lib.CrocodileHead_003 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{"dirty":0,"dirty_stop":1,"clean":2,"clean_loop":3,"glow":4,"glow_loop":5,"wash":6,"wash_stop":155,"glowclean":156,"glowclean_loop":157,"final":158,"final_loop":159});

	// bubbles
	this.instance = new lib.CrocodileHead_001_bubbles();
	this.instance.parent = this;
	this.instance.setTransform(100,-3,0.667,0.616,0,-23.5,156.5,-93.6,63.2);
	this.instance.shadow = new cjs.Shadow("rgba(0,0,0,1)",0,0,2);
	this.instance._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(6).to({_off:false},0).wait(36).to({regX:-24.1,regY:20.4,rotation:23.5,skewX:0,skewY:0,x:3.1,y:-3.7},0).to({_off:true},113).wait(6));

	// Crocodile Head_0030001.png
	this.instance_1 = new lib.CrocodileHead_0030002();
	this.instance_1.parent = this;
	this.instance_1.setTransform(-45.2,-29,0.5,0.5);

	this.instance_2 = new lib.left_over_bubbles_sparse();
	this.instance_2.parent = this;
	this.instance_2.setTransform(29.5,-12.7,0.5,0.5,0,0,0,47.7,10.1);

	this.instance_3 = new lib.left_over_bubbles();
	this.instance_3.parent = this;
	this.instance_3.setTransform(8.6,-3.9,0.5,0.5,-15,0,0,50.6,5.2);

	this.instance_4 = new lib.CrocodileHead_0030001();
	this.instance_4.parent = this;
	this.instance_4.setTransform(-45.2,-29,0.5,0.5);

	this.instance_5 = new lib.croc_mouthGlow();
	this.instance_5.parent = this;
	this.instance_5.setTransform(8.6,1.7,1.248,0.999,0,-29.9,150.1,32.3,12);

	this.glow = new lib.blueglowmouth();
	this.glow.parent = this;
	this.glow.setTransform(10.6,-3.9,1,1,0,-22.9,157.1,32.4,12.1);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_1}]}).to({state:[{t:this.instance_4},{t:this.instance_3},{t:this.instance_2}]},2).to({state:[{t:this.instance_1},{t:this.instance_5}]},2).to({state:[{t:this.instance_4}]},2).to({state:[{t:this.instance_4},{t:this.glow}]},149).to({state:[{t:this.instance_4}]},3).to({state:[]},2).wait(1));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-45.2,-30,98,74);


(lib.CrocodileHead_002 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{"dirty":0,"dirty_stop":1,"clean":2,"clean_loop":3,"glow":4,"glow_loop":5,"wash":6,"wash_stop":155,"glowclean":156,"glowclean_loop":157,"final":158,"final_loop":159});

	// bubbles
	this.instance = new lib.CrocodileHead_001_bubbles();
	this.instance.parent = this;
	this.instance.setTransform(100,-3,0.667,0.616,0,-23.5,156.5,-93.6,63.2);
	this.instance.shadow = new cjs.Shadow("rgba(0,0,0,1)",0,0,2);
	this.instance._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(6).to({_off:false},0).wait(36).to({regX:-24.1,regY:20.4,rotation:23.5,skewX:0,skewY:0,x:3.1,y:-3.7},0).to({_off:true},113).wait(6));

	// Eye
	this.instance_1 = new lib.CrocodileHead_0020002();
	this.instance_1.parent = this;
	this.instance_1.setTransform(-45,-27.1,0.5,0.5);

	this.instance_2 = new lib.left_over_bubbles_sparse();
	this.instance_2.parent = this;
	this.instance_2.setTransform(35.8,-13.7,0.5,0.5,0,0,0,47.7,10.1);

	this.instance_3 = new lib.left_over_bubbles();
	this.instance_3.parent = this;
	this.instance_3.setTransform(14.9,-4.9,0.5,0.5,-15,0,0,50.6,5.2);

	this.instance_4 = new lib.CrocodileHead_0020001();
	this.instance_4.parent = this;
	this.instance_4.setTransform(-45,-27.1,0.5,0.5);

	this.instance_5 = new lib.croc_mouthGlow();
	this.instance_5.parent = this;
	this.instance_5.setTransform(10.4,6.2,1.25,1.25,0,-30,150,32.4,12);

	this.glow = new lib.blueglowmouth();
	this.glow.parent = this;
	this.glow.setTransform(10.6,-3.9,1,1,0,-15,165,32.4,12.1);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_1}]}).to({state:[{t:this.instance_4},{t:this.instance_3},{t:this.instance_2}]},2).to({state:[{t:this.instance_1},{t:this.instance_5}]},2).to({state:[{t:this.instance_4}]},2).to({state:[{t:this.instance_4},{t:this.glow}]},150).to({state:[{t:this.instance_4}]},2).to({state:[]},2).wait(1));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-45,-30.3,98,74.3);


(lib.Croc = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{wrongAnswer:0,rest:42,rest_stop:139,"clean":141,"clean_stop":154,wet:155,wet_stop:173,excited:175,excited_stop:265,animalSound:267});

	// timeline functions:
	this.frame_40 = function() {
		/* gotoAndPlay("rest");*/
	}
	this.frame_139 = function() {
		/* stop();
		
		gameObjects._animal.restTimeout();*/
	}
	this.frame_153 = function() {
		/* stop();*/
	}
	this.frame_173 = function() {
		/* stop();*/
	}
	this.frame_265 = function() {
		/* 
		
		gameObjects._game.done();
		stop();*/
	}
	this.frame_307 = function() {
		/* gotoAndPlay("rest");*/
	}

	// actions tween:
	this.timeline.addTween(cjs.Tween.get(this).wait(40).call(this.frame_40).wait(99).call(this.frame_139).wait(14).call(this.frame_153).wait(20).call(this.frame_173).wait(92).call(this.frame_265).wait(42).call(this.frame_307).wait(1));

	// sparkle
	this.instance = new lib.sparkle();
	this.instance.parent = this;
	this.instance.setTransform(364.7,183.2,0.727,0.727);
	this.instance._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(237).to({_off:false},0).to({_off:true},30).wait(41));

	// sparkle
	this.instance_1 = new lib.sparkle();
	this.instance_1.parent = this;
	this.instance_1.setTransform(503.7,199.7,0.404,0.404);
	this.instance_1._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance_1).wait(231).to({_off:false},0).to({_off:true},36).wait(41));

	// sparkle
	this.instance_2 = new lib.sparkle();
	this.instance_2.parent = this;
	this.instance_2.setTransform(432.9,209.8,0.75,0.75);
	this.instance_2._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance_2).wait(245).to({_off:false},0).to({_off:true},22).wait(41));

	// Crocodile Head_001
	this.mouth_bubbles = new lib.CrocodileHead_001_bubbles();
	this.mouth_bubbles.parent = this;
	this.mouth_bubbles.setTransform(283.3,191.5,0.667,0.616,0,-23.5,156.5,-24.1,20.4);
	this.mouth_bubbles.shadow = new cjs.Shadow("rgba(0,0,0,1)",0,0,2);

	this.timeline.addTween(cjs.Tween.get(this.mouth_bubbles).wait(42).to({x:283.4,y:191.2},0).to({_off:true},113).wait(153));

	// Croc Lower Hind Leg
	this.foot_bubbles = new lib.CrocLowerHindLeg_bubbles();
	this.foot_bubbles.parent = this;
	this.foot_bubbles.setTransform(370.6,202.9,0.54,0.54,0,-1,179,29.2,17.2);
	this.foot_bubbles.shadow = new cjs.Shadow("rgba(0,0,0,1)",0,0,3);

	this.timeline.addTween(cjs.Tween.get(this.foot_bubbles).wait(42).to({x:370.8,y:202.6},0).to({_off:true},113).wait(153));

	// Crocodile Tail
	this.tail_bubbles = new lib.CrocodileTail_bubbles();
	this.tail_bubbles.parent = this;
	this.tail_bubbles.setTransform(396.8,197.4,0.54,0.54,0,-1,179,153,-9.6);
	this.tail_bubbles.shadow = new cjs.Shadow("rgba(0,0,0,1)",0,0,2);

	this.timeline.addTween(cjs.Tween.get(this.tail_bubbles).wait(42).to({x:397,y:197.1},0).to({_off:true},113).wait(153));

	// Crocodile Torso
	this.back_bubbles = new lib.CrocodileTorso_bubbles();
	this.back_bubbles.parent = this;
	this.back_bubbles.setTransform(348.3,199.2,0.54,0.54,0,-1,179);
	this.back_bubbles.shadow = new cjs.Shadow("rgba(0,0,0,1)",0,0,2);

	this.timeline.addTween(cjs.Tween.get(this.back_bubbles).wait(42).to({x:348.4,y:198.9},0).to({_off:true},113).wait(153));

	// sparkle
	this.instance_3 = new lib.sparkle();
	this.instance_3.parent = this;
	this.instance_3.setTransform(376.3,219.6,0.615,0.615);
	this.instance_3._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance_3).wait(223).to({_off:false},0).to({_off:true},44).wait(41));

	// sparkle
	this.instance_4 = new lib.sparkle();
	this.instance_4.parent = this;
	this.instance_4.setTransform(313.3,210.3,0.75,0.75);
	this.instance_4._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance_4).wait(251).to({_off:false},0).to({_off:true},16).wait(41));

	// Layer 3
	this.instance_5 = new lib.water_drops_018();
	this.instance_5.parent = this;
	this.instance_5.setTransform(390.4,199.7,0.4,0.4,0,0,180,132.2,67);
	this.instance_5._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance_5).wait(155).to({_off:false},0).to({_off:true},20).wait(133));

	// sparkle
	this.instance_6 = new lib.sparkle();
	this.instance_6.parent = this;
	this.instance_6.setTransform(264.1,183.9,0.481,0.481);
	this.instance_6._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance_6).wait(259).to({_off:false},0).to({_off:true},8).wait(41));

	// Crocodile Head
	this.croc_head = new lib.CrocodileHead_001();
	this.croc_head.parent = this;
	this.croc_head.setTransform(283.3,191.5,0.667,0.616,0,-23.5,156.5,-24.1,20.4);

	this.croc_head_1 = new lib.CrocodileHead_002();
	this.croc_head_1.parent = this;
	this.croc_head_1.setTransform(283.2,191.1,0.666,0.615,0,-22.8,157.2,-24,20.4);

	this.croc_head_2 = new lib.CrocodileHead_003();
	this.croc_head_2.parent = this;
	this.croc_head_2.setTransform(283.1,190.8,0.666,0.615,0,-22,158,-23.8,20.4);

	this.croc_head_3 = new lib.CrocodileHead_004();
	this.croc_head_3.parent = this;
	this.croc_head_3.setTransform(283.3,190.4,0.666,0.615,0,-21.3,158.7,-24.1,20.7);
	this.croc_head_3._off = true;

	this.croc_head_4 = new lib.CrocodileHead_005();
	this.croc_head_4.parent = this;
	this.croc_head_4.setTransform(283.2,190,0.666,0.615,0,-20.6,159.4,-24,20.5);

	this.croc_head_5 = new lib.CrocodileHead_006();
	this.croc_head_5.parent = this;
	this.croc_head_5.setTransform(283.2,189.6,0.666,0.615,0,-19.8,160.2,-24,20.4);

	this.croc_head_6 = new lib.CrocodileHead_007();
	this.croc_head_6.parent = this;
	this.croc_head_6.setTransform(283.3,189.2,0.666,0.615,0,-19.1,160.9,-24.2,20.4);

	this.croc_head_7 = new lib.CrocodileHead_008();
	this.croc_head_7.parent = this;
	this.croc_head_7.setTransform(283.3,188.7,0.666,0.615,0,-18.3,161.7,-24.1,20.4);

	this.croc_head_8 = new lib.CrocodileHead_009();
	this.croc_head_8.parent = this;
	this.croc_head_8.setTransform(283.1,188.4,0.666,0.615,0,-17.8,162.2,-23.9,20.2);

	this.croc_head_9 = new lib.CrocodileHead_010();
	this.croc_head_9.parent = this;
	this.croc_head_9.setTransform(283.4,188,0.667,0.616,0,-17,163,-24.3,20.4);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.croc_head}]}).to({state:[{t:this.croc_head}]},2).to({state:[{t:this.croc_head}]},2).to({state:[{t:this.croc_head}]},2).to({state:[{t:this.croc_head}]},2).to({state:[{t:this.croc_head}]},8).to({state:[{t:this.croc_head}]},2).to({state:[{t:this.croc_head}]},2).to({state:[{t:this.croc_head}]},2).to({state:[{t:this.croc_head}]},20).to({state:[{t:this.croc_head}]},26).to({state:[{t:this.croc_head_1}]},1).to({state:[{t:this.croc_head_2}]},1).to({state:[{t:this.croc_head_3}]},1).to({state:[{t:this.croc_head_4}]},1).to({state:[{t:this.croc_head_5,p:{regX:-24,skewX:-19.8,skewY:160.2,x:283.2,y:189.6}}]},1).to({state:[{t:this.croc_head_6,p:{regX:-24.2,skewX:-19.1,skewY:160.9,x:283.3,y:189.2}}]},1).to({state:[{t:this.croc_head_7,p:{regX:-24.1,regY:20.4,skewX:-18.3,skewY:161.7,y:188.7,x:283.3}}]},1).to({state:[{t:this.croc_head_8}]},1).to({state:[{t:this.croc_head_9,p:{regX:-24.3,skewX:-17,skewY:163,x:283.4,y:188}}]},1).to({state:[{t:this.croc_head_9,p:{regX:-24.3,skewX:-17,skewY:163,x:283.4,y:188}}]},48).to({state:[{t:this.croc_head_7,p:{regX:-24.2,regY:20.6,skewX:-19.1,skewY:160.9,y:189.3,x:283.3}}]},1).to({state:[{t:this.croc_head_3}]},1).to({state:[{t:this.croc_head}]},1).to({state:[{t:this.croc_head}]},13).to({state:[{t:this.croc_head}]},14).to({state:[{t:this.croc_head}]},20).to({state:[{t:this.croc_head}]},6).to({state:[{t:this.croc_head}]},2).to({state:[{t:this.croc_head}]},2).to({state:[{t:this.croc_head}]},2).to({state:[{t:this.croc_head}]},2).to({state:[{t:this.croc_head_3}]},2).to({state:[{t:this.croc_head_6,p:{regX:-23.9,skewX:-10.5,skewY:169.5,x:263,y:181.9}}]},2).to({state:[{t:this.croc_head_9,p:{regX:-24.2,skewX:0.5,skewY:-179.5,x:261.1,y:180.8}}]},2).to({state:[{t:this.croc_head_7,p:{regX:-24.3,regY:20.4,skewX:-11.5,skewY:168.5,y:186.2,x:272.2}}]},32).to({state:[{t:this.croc_head_5,p:{regX:-24.3,skewX:-17.5,skewY:162.5,x:277.8,y:188.9}}]},2).to({state:[{t:this.croc_head_3}]},2).to({state:[{t:this.croc_head}]},2).to({state:[{t:this.croc_head}]},34).to({state:[{t:this.croc_head}]},2).to({state:[{t:this.croc_head}]},2).to({state:[{t:this.croc_head}]},2).to({state:[{t:this.croc_head}]},2).to({state:[{t:this.croc_head}]},2).to({state:[{t:this.croc_head_3}]},2).to({state:[{t:this.croc_head_6,p:{regX:-23.9,skewX:-10.5,skewY:169.5,x:263,y:181.9}}]},2).to({state:[{t:this.croc_head_9,p:{regX:-24.2,skewX:0.5,skewY:-179.5,x:261.1,y:180.8}}]},2).to({state:[{t:this.croc_head_7,p:{regX:-24.3,regY:20.4,skewX:-11.5,skewY:168.5,y:186.2,x:272.2}}]},12).to({state:[{t:this.croc_head_5,p:{regX:-24.3,skewX:-17.5,skewY:162.5,x:277.8,y:188.9}}]},2).to({state:[{t:this.croc_head_3}]},2).to({state:[{t:this.croc_head}]},2).wait(7));
	this.timeline.addTween(cjs.Tween.get(this.croc_head).wait(4).to({regX:-24,scaleX:0.67,scaleY:0.62,skewX:-22.8,skewY:157.2,x:283.2,y:191.1},0).wait(2).to({regX:-23.8,skewX:-22,skewY:158,x:283.1,y:190.8},0).wait(2).to({regX:-24.1,regY:20.7,skewX:-21.3,skewY:158.7,x:283.3,y:190.4},0).wait(8).to({regX:-23.8,regY:20.4,skewX:-22,skewY:158,x:283.1,y:190.8},0).wait(2).to({regX:-24,skewX:-22.8,skewY:157.2,x:283.2,y:191.1},0).wait(2).to({regX:-24.1,scaleX:0.67,scaleY:0.62,skewX:-23.5,skewY:156.5,x:283.3,y:191.5},0).wait(48).to({_off:true},1).wait(59).to({_off:false,x:283.4,y:191.2},0).wait(13).to({x:283.3,y:191.5},0).wait(42).to({regX:-23.8,regY:20.5,scaleX:0.67,scaleY:0.62,skewX:-34.9,skewY:145.1,x:287.3,y:193.3},0).wait(2).to({regX:-23.9,regY:20.4,scaleX:0.67,scaleY:0.62,skewX:-46.4,skewY:133.6,x:291.6,y:194.8},0).wait(2).to({regX:-24,regY:20.7,scaleX:0.67,scaleY:0.62,skewX:-45.1,skewY:134.9,x:280.5,y:190.1},0).wait(2).to({regX:-24.2,regY:20.6,scaleX:0.67,scaleY:0.62,skewX:-44,skewY:136,x:269.2,y:185.1},0).to({_off:true},2).wait(42).to({_off:false,regX:-24.1,regY:20.4,skewX:-23.5,skewY:156.5,x:283.3,y:191.5},0).wait(38).to({regX:-23.8,regY:20.5,scaleX:0.67,scaleY:0.62,skewX:-34.9,skewY:145.1,x:287.3,y:193.3},0).wait(2).to({regX:-23.9,regY:20.4,scaleX:0.67,scaleY:0.62,skewX:-46.4,skewY:133.6,x:291.6,y:194.8},0).wait(2).to({regX:-24,regY:20.7,scaleX:0.67,scaleY:0.62,skewX:-45.1,skewY:134.9,x:280.5,y:190.1},0).wait(2).to({regX:-24.2,regY:20.6,scaleX:0.67,scaleY:0.62,skewX:-44,skewY:136,x:269.2,y:185.1},0).to({_off:true},2).wait(22).to({_off:false,regX:-24.1,regY:20.4,skewX:-23.5,skewY:156.5,x:283.3,y:191.5},0).wait(7));
	this.timeline.addTween(cjs.Tween.get(this.croc_head_3).wait(71).to({_off:false},0).to({_off:true},1).wait(55).to({_off:false,regX:-24.2,regY:20.4,x:283.2},0).to({_off:true},1).wait(63).to({_off:false,regX:-24.1,skewX:-21.6,skewY:158.4,x:265.1,y:182.9},0).to({_off:true},2).wait(38).to({_off:false,regX:-24.6,skewX:-20.5,skewY:159.5,x:280.8,y:190.1},0).to({_off:true},2).wait(46).to({_off:false,regX:-24.1,skewX:-21.6,skewY:158.4,x:265.1,y:182.9},0).to({_off:true},2).wait(18).to({_off:false,regX:-24.6,skewX:-20.5,skewY:159.5,x:280.8,y:190.1},0).to({_off:true},2).wait(7));

	// Croc Front Leg
	this.croc_frontleg = new lib.CrocFrontLeg();
	this.croc_frontleg.parent = this;
	this.croc_frontleg.setTransform(314.6,201.3,0.54,0.54,0,-1,179,-25,-25.4);

	this.timeline.addTween(cjs.Tween.get(this.croc_frontleg).wait(2).to({regY:-25.2,y:201.4},0).wait(2).to({regX:-19.4,regY:-22.7,skewX:-1.5,skewY:178.5,x:311.7,y:202.9},0).wait(2).to({regX:-19.5,regY:-22.4,skewX:-2,skewY:178,y:203.2},0).wait(2).to({regX:-19.4,regY:-22.7,skewX:-2.5,skewY:177.5,x:311.6},0).wait(8).to({regX:-19.5,regY:-22.4,skewX:-2,skewY:178,x:311.7},0).wait(2).to({regX:-19.4,regY:-22.7,skewX:-1.5,skewY:178.5,y:202.9},0).wait(2).to({regX:-25,regY:-25.4,skewX:-1,skewY:179,x:314.6,y:201.3},0).wait(48).to({regY:-25.1,y:201.5},0).wait(1).to({regX:-19.4,regY:-22.7,skewX:-1.5,skewY:178.5,x:311.7,y:202.9},0).wait(1).to({regX:-19.5,regY:-22.4,skewX:-2,skewY:178,y:203.2},0).wait(1).to({regX:-19.4,regY:-22.7,skewX:-2.5,skewY:177.5,x:311.6},0).wait(1).to({regX:-19.5,skewX:-3,skewY:177,x:311.7,y:203.3},0).wait(1).to({regX:-19.4,regY:-22.6,skewX:-3.6,skewY:176.4,y:203.5},0).wait(1).to({regY:-22.8,skewX:-4.3,skewY:175.7},0).wait(1).to({regX:-19.6,regY:-23,skewX:-4.8,skewY:175.2,x:311.8,y:203.4},0).wait(1).to({regX:-19.7,regY:-22.6,scaleX:0.54,scaleY:0.54,skewX:-5,skewY:175,x:311.9,y:203.6},0).wait(1).to({regX:-19.2,regY:-22.7,scaleX:0.54,scaleY:0.54,skewX:-5.3,skewY:174.7,x:311.6,y:203.7},0).wait(49).to({skewX:-3.8,skewY:176.2,y:203.4},0).wait(1).to({regY:-22.8,skewX:-2.3,skewY:177.7,y:203.1},0).wait(1).to({regX:-25,regY:-25.4,skewX:-1,skewY:179,x:314.8,y:201},0).wait(13).to({regY:-25.2,x:314.6,y:201.4},0).wait(14).to({regY:-25.1,y:201.5},0).wait(26).to({regY:-25.4,y:201.3},0).wait(2).to({regX:-24.1,regY:-22.7,skewX:-2.3,skewY:177.7,x:315.4,y:203.6},0).wait(2).to({regX:-19,regY:-17.8,skewX:-3.7,skewY:176.3,x:316.7,y:203.5},0).wait(2).to({regY:-17.7,scaleX:0.54,scaleY:0.54,skewX:-19.3,skewY:160.7,x:309.7,y:199.6},0).wait(2).to({regX:-19.4,regY:-18,scaleX:0.54,scaleY:0.54,skewX:-35,skewY:145,x:302.7,y:195.5},0).wait(2).to({regX:-19.2,regY:-18.1,scaleX:0.54,scaleY:0.54,skewX:-26.3,skewY:153.7,x:304.7,y:195.8},0).wait(2).to({skewX:-22,skewY:158,x:305.7,y:195.9},0).wait(2).to({regX:-19.6,regY:-17.9,scaleX:0.54,scaleY:0.54,skewX:-17.9,skewY:162.1,x:306.8,y:196.1},0).wait(32).to({regX:-19.8,scaleX:0.54,scaleY:0.54,skewX:-9.3,skewY:170.7,x:309.3,y:200.1},0).wait(2).to({regX:-19.7,regY:-18,scaleX:0.54,scaleY:0.54,skewX:-5.1,skewY:174.9,x:310.5,y:202.3},0).wait(2).to({regY:-17.8,skewX:-3,skewY:177,x:311.1,y:203.9},0).wait(2).to({regX:-25,regY:-25.4,skewX:-1,skewY:179,x:314.6,y:201.3},0).wait(34).to({regY:-25.2,y:201.4},0).wait(2).to({regY:-25.4,y:201.3},0).wait(2).to({regX:-24.1,regY:-22.8,skewX:-2.3,skewY:177.7,x:315.4,y:203.5},0).wait(2).to({regX:-19,regY:-17.8,skewX:-3.7,skewY:176.3,x:316.7},0).wait(2).to({regY:-17.7,scaleX:0.54,scaleY:0.54,skewX:-19.3,skewY:160.7,x:309.7,y:199.6},0).wait(2).to({regX:-19.4,regY:-18,scaleX:0.54,scaleY:0.54,skewX:-35,skewY:145,x:302.7,y:195.5},0).wait(2).to({regX:-19.2,regY:-18.1,scaleX:0.54,scaleY:0.54,skewX:-26.3,skewY:153.7,x:304.7,y:195.8},0).wait(2).to({skewX:-22,skewY:158,x:305.7,y:195.9},0).wait(2).to({regX:-19.6,regY:-17.9,scaleX:0.54,scaleY:0.54,skewX:-17.9,skewY:162.1,x:306.8,y:196.1},0).wait(12).to({regX:-19.8,scaleX:0.54,scaleY:0.54,skewX:-9.3,skewY:170.7,x:309.3,y:200.1},0).wait(2).to({regX:-19.7,regY:-18,scaleX:0.54,scaleY:0.54,skewX:-5.1,skewY:174.9,x:310.5,y:202.3},0).wait(2).to({regY:-17.8,skewX:-3,skewY:177,x:311.1,y:203.9},0).wait(2).to({regX:-25,regY:-25.4,skewX:-1,skewY:179,x:314.6,y:201.3},0).wait(7));

	// Croc Lower Hind Leg
	this.croc_hindleg = new lib.CrocLowerHindLeg();
	this.croc_hindleg.parent = this;
	this.croc_hindleg.setTransform(370.6,202.9,0.54,0.54,0,-1,179,29.2,17.2);

	this.timeline.addTween(cjs.Tween.get(this.croc_hindleg).wait(4).to({regY:17,scaleY:0.55,skewX:-0.8,skewY:179.2,x:370.7,y:202.6},0).wait(2).to({regY:17.2,scaleY:0.56,y:202.3},0).wait(2).to({scaleY:0.57,y:202.1},0).wait(8).to({scaleY:0.56,y:202.3},0).wait(2).to({regY:17,scaleY:0.55,y:202.6},0).wait(2).to({regY:17.2,scaleY:0.54,skewX:-1,skewY:179,x:370.6,y:202.9},0).wait(49).to({regY:17,scaleY:0.55,skewX:-0.8,skewY:179.2,x:370.7,y:202.6},0).wait(1).to({regY:17.2,scaleY:0.56,y:202.3},0).wait(1).to({scaleY:0.57,y:202.1},0).wait(1).to({regY:17.1,scaleY:0.58,y:201.7},0).wait(1).to({scaleY:0.59,y:201.5},0).wait(1).to({regY:17.2,scaleY:0.6,y:201.2},0).wait(1).to({scaleY:0.6,y:200.9},0).wait(1).to({regY:16.9,scaleY:0.61,y:200.5},0).wait(1).to({regY:17.2,scaleY:0.62,skewX:-1,skewY:179,y:200.4},0).wait(49).to({regX:29.1,scaleY:0.6,skewX:-0.8,skewY:179.2,y:201.2},0).wait(1).to({regX:29.2,scaleY:0.57,x:370.6,y:202.1},0).wait(1).to({scaleY:0.54,skewX:-1,skewY:179,x:370.8,y:202.6},0).wait(13).to({x:370.6,y:202.9},0).wait(42).to({scaleY:0.55,skewX:0.5,skewY:173.5,x:372.4,y:201.2},0).wait(2).to({regX:29.3,scaleY:0.56,skewX:2,skewY:167.8,x:374.1,y:199.4},0).wait(2).to({regX:29.4,scaleX:0.54,scaleY:0.55,skewX:0.3,skewY:170.7,y:199.5},0).wait(2).to({regX:29.1,regY:17.3,scaleX:0.54,scaleY:0.54,skewX:-1.4,skewY:173.4,x:374.2},0).wait(2).to({regX:29.2,regY:17.4,scaleX:0.54,scaleY:0.56,skewX:-1,skewY:176.2,x:372.2,y:199.8},0).wait(2).to({scaleX:0.54,scaleY:0.57,skewY:177.7,x:371.3,y:199.9},0).wait(2).to({regY:17.2,scaleY:0.57,skewY:179,x:370.3,y:200},0).wait(32).to({scaleY:0.56,skewX:-0.8,skewY:179.2,x:370.5,y:201.5},0).wait(2).to({regY:17.1,scaleY:0.55,x:370.6,y:202.2},0).wait(2).to({scaleY:0.54,x:370.7,y:202.6},0).wait(2).to({regY:17.2,scaleY:0.54,skewX:-1,skewY:179,x:370.6,y:202.9},0).wait(38).to({scaleY:0.55,skewX:0.5,skewY:173.5,x:372.4,y:201.2},0).wait(2).to({regX:29.3,scaleY:0.56,skewX:2,skewY:167.8,x:374.1,y:199.4},0).wait(2).to({regX:29.4,scaleX:0.54,scaleY:0.55,skewX:0.3,skewY:170.7,y:199.5},0).wait(2).to({regX:29.1,regY:17.3,scaleX:0.54,scaleY:0.54,skewX:-1.4,skewY:173.4,x:374.2},0).wait(2).to({regX:29.2,regY:17.4,scaleX:0.54,scaleY:0.56,skewX:-1,skewY:176.2,x:372.2,y:199.8},0).wait(2).to({scaleX:0.54,scaleY:0.57,skewY:177.7,x:371.3,y:199.9},0).wait(2).to({regY:17.2,scaleY:0.57,skewY:179,x:370.3,y:200},0).wait(12).to({scaleY:0.56,skewX:-0.8,skewY:179.2,x:370.5,y:201.5},0).wait(2).to({regY:17.1,scaleY:0.55,x:370.6,y:202.2},0).wait(2).to({scaleY:0.54,x:370.7,y:202.6},0).wait(2).to({regY:17.2,scaleY:0.54,skewX:-1,skewY:179,x:370.6,y:202.9},0).wait(7));

	// Croc Hind Leg Upper
	this.instance_7 = new lib.CrocHindLegUpper_1();
	this.instance_7.parent = this;
	this.instance_7.setTransform(400.1,210.6,0.54,0.54,0,-1,179,11.1,31.9);

	this.timeline.addTween(cjs.Tween.get(this.instance_7).wait(4).to({regX:11.2,skewX:-0.5,skewY:179.5},0).wait(2).to({regX:11.1,skewX:-0.1,skewY:179.9},0).wait(2).to({regX:10.2,regY:38.1,skewX:0,skewY:180,x:400.6,y:214},0).wait(8).to({regX:11.1,regY:31.9,skewX:-0.1,skewY:179.9,x:400.1,y:210.6},0).wait(2).to({regX:11.2,skewX:-0.5,skewY:179.5},0).wait(2).to({regX:11.1,skewX:-1,skewY:179},0).wait(49).to({regX:11.2,skewX:-0.5,skewY:179.5},0).wait(1).to({regX:11.1,skewX:-0.1,skewY:179.9},0).wait(1).to({regX:10.2,regY:38.1,skewX:0,skewY:180,x:400.6,y:214},0).wait(1).to({regX:11.1,regY:31.9,skewX:0.5,skewY:180.5,x:400.1,y:210.6},0).wait(1).to({regX:11.2,skewX:0.8,skewY:180.8,y:210.7},0).wait(1).to({regY:31.7,skewX:1.3,skewY:181.3,y:210.6},0).wait(1).to({regX:11.1,regY:31.9,skewX:1.6,skewY:181.6,y:210.7},0).wait(1).to({regY:31.8,skewX:2,skewY:182,y:210.8},0).wait(1).to({regX:11.2,regY:32.2,skewX:2.5,skewY:182.5,y:210.7},0).wait(49).to({regX:10.8,regY:32,skewX:1.3,skewY:181.3,x:400.2,y:210.6},0).wait(1).to({regX:11.2,regY:32.4,skewX:0,skewY:180,x:400,y:210.8},0).wait(1).to({regX:11.1,regY:31.9,skewX:-1,skewY:179,x:400.3,y:210.3},0).wait(13).to({x:400.1,y:210.6},0).wait(42).to({regX:11.4,scaleX:0.52,skewX:-0.8,skewY:181,x:400},0).wait(2).to({regX:11.1,scaleX:0.49,skewX:-1,skewY:183.2,x:400.1},0).wait(2).to({regY:32,scaleX:0.49,skewX:-0.8,skewY:184.8,y:210.7},0).wait(2).to({regY:31.9,scaleX:0.5,skewX:-1,skewY:186.5,y:210.5},0).wait(2).to({scaleX:0.51,skewX:0,skewY:183.5,x:399,y:209.5},0).wait(2).to({regX:11.2,scaleX:0.52,skewX:0.3,skewY:182,x:398.4,y:208.9},0).wait(2).to({regX:11.3,scaleX:0.53,skewX:0.8,skewY:180.8,x:397.8,y:208.3},0).wait(32).to({scaleX:0.53,skewX:0,skewY:180,x:399,y:209.5},0).wait(2).to({regY:31.8,scaleX:0.54,skewX:-0.5,skewY:179.5,x:399.6,y:210},0).wait(2).to({scaleX:0.54,skewX:-0.6,skewY:179.4,x:399.9,y:210.3},0).wait(2).to({regX:11.1,regY:31.9,scaleX:0.54,skewX:-1,skewY:179,x:400.1,y:210.6},0).wait(38).to({regX:11.4,scaleX:0.52,skewX:-0.8,skewY:181,x:400},0).wait(2).to({regX:11.1,scaleX:0.49,skewX:-1,skewY:183.2,x:400.1},0).wait(2).to({regY:32,scaleX:0.49,skewX:-0.8,skewY:184.8,y:210.7},0).wait(2).to({regY:31.9,scaleX:0.5,skewX:-1,skewY:186.5,y:210.5},0).wait(2).to({scaleX:0.51,skewX:0,skewY:183.5,x:399,y:209.5},0).wait(2).to({regX:11.2,scaleX:0.52,skewX:0.3,skewY:182,x:398.4,y:208.9},0).wait(2).to({regX:11.3,scaleX:0.53,skewX:0.8,skewY:180.8,x:397.8,y:208.3},0).wait(12).to({scaleX:0.53,skewX:0,skewY:180,x:399,y:209.5},0).wait(2).to({regY:31.8,scaleX:0.54,skewX:-0.5,skewY:179.5,x:399.6,y:210},0).wait(2).to({scaleX:0.54,skewX:-0.6,skewY:179.4,x:399.9,y:210.3},0).wait(2).to({regX:11.1,regY:31.9,scaleX:0.54,skewX:-1,skewY:179,x:400.1,y:210.6},0).wait(7));

	// Crocodile Tail
	this.croc_tail = new lib.CrocodileTail();
	this.croc_tail.parent = this;
	this.croc_tail.setTransform(396.8,197.4,0.54,0.54,0,-1,179,153,-9.6);

	this.timeline.addTween(cjs.Tween.get(this.croc_tail).wait(4).to({regX:152.8,skewX:-0.8,skewY:179.2,x:396.9},0).wait(16).to({regX:153,skewX:-1,skewY:179,x:396.8},0).wait(49).to({regX:152.8,skewX:-0.8,skewY:179.2,x:396.9},0).wait(8).to({regX:153,skewX:-1,skewY:179,x:396.8},0).wait(49).to({regX:152.8,skewX:-0.8,skewY:179.2,x:396.9},0).wait(2).to({regX:153,skewX:-1,skewY:179,x:397,y:197.1},0).wait(13).to({x:396.8,y:197.4},0).wait(42).to({regX:152.7,skewX:-0.8,skewY:179.2,x:397.6},0).wait(2).to({regX:153,skewX:-1,skewY:179,x:398},0).wait(2).to({regX:153.1,scaleX:0.54,skewX:-0.8,skewY:179.4,x:398.1},0).wait(2).to({regY:-9.7,scaleX:0.54,skewX:-1,skewY:179.5,x:397.9,y:197.3},0).wait(2).to({regX:152.7,regY:-19.8,scaleX:0.54,skewX:-0.8,skewY:180.3,x:396.7,y:190.2},0).wait(2).to({regX:152.9,regY:-9.7,scaleX:0.54,skewY:180.8,x:396,y:194.8},0).wait(2).to({regX:153.1,regY:-9.6,scaleX:0.54,skewX:-1,skewY:181.3,x:395.1,y:193.9},0).wait(32).to({regX:152.8,regY:0.5,skewX:-0.8,skewY:180,x:396.2,y:201.2},0).wait(2).to({regY:-9.6,skewY:179.7,x:396.5,y:196.6},0).wait(2).to({regX:152.9,regY:-10,skewY:179.5,x:396.7,y:196.7},0).wait(2).to({regX:153,regY:-9.6,skewX:-1,skewY:179,x:396.8,y:197.4},0).wait(38).to({regX:152.7,skewX:-0.8,skewY:179.2,x:397.6},0).wait(2).to({regX:153,skewX:-1,skewY:179,x:398},0).wait(2).to({regX:153.1,scaleX:0.54,skewX:-0.8,skewY:179.4,x:398.1},0).wait(2).to({regY:-9.7,scaleX:0.54,skewX:-1,skewY:179.5,x:397.9,y:197.3},0).wait(2).to({regX:152.7,regY:-19.7,scaleX:0.54,skewX:-0.8,skewY:180.3,x:396.7,y:190.2},0).wait(2).to({regX:152.9,regY:-9.7,scaleX:0.54,skewY:180.8,x:396,y:194.8},0).wait(2).to({regX:153.1,regY:-9.6,scaleX:0.54,skewX:-1,skewY:181.3,x:395.1,y:193.9},0).wait(12).to({regX:152.8,regY:0.5,skewX:-0.8,skewY:180,x:396.2,y:201.2},0).wait(2).to({regY:-9.6,skewY:179.7,x:396.5,y:196.6},0).wait(2).to({regX:152.9,regY:-10,skewY:179.5,x:396.7,y:196.7},0).wait(2).to({regX:153,regY:-9.6,skewX:-1,skewY:179,x:396.8,y:197.4},0).wait(7));

	// Crocodile Neck
	this.instance_8 = new lib.CrocodileNeck_1();
	this.instance_8.parent = this;
	this.instance_8.setTransform(309.4,197.6,0.54,0.54,0,-1,179,-24.8,5.5);

	this.timeline.addTween(cjs.Tween.get(this.instance_8).wait(4).to({skewX:-1.5,skewY:178.5,x:309.8,y:197.3},0).wait(2).to({regX:-25.1,regY:3.9,skewX:-2,skewY:178,x:310.1,y:196.1},0).wait(2).to({regX:-24.8,regY:5.5,skewX:-2.8,skewY:177.2,x:310.2,y:196.6},0).wait(8).to({regX:-25.1,regY:3.9,skewX:-2,skewY:178,x:310.1,y:196.1},0).wait(2).to({regX:-24.8,regY:5.5,skewX:-1.5,skewY:178.5,x:309.8,y:197.3},0).wait(2).to({skewX:-1,skewY:179,x:309.4,y:197.6},0).wait(49).to({skewX:-1.5,skewY:178.5,x:309.8,y:197.3},0).wait(1).to({regX:-25.1,regY:3.9,skewX:-2,skewY:178,x:310.1,y:196.1},0).wait(1).to({regX:-24.8,regY:5.5,skewX:-2.8,skewY:177.2,x:310.2,y:196.6},0).wait(1).to({skewX:-3.3,skewY:176.7,x:310.5,y:196.3},0).wait(1).to({skewX:-3.8,skewY:176.2,x:310.8,y:196},0).wait(1).to({regX:-25.1,regY:5.6,skewX:-4.5,skewY:175.5,x:311.2,y:195.7},0).wait(1).to({regX:-24.7,regY:5.7,skewX:-5.1,skewY:174.9,x:311.3,y:195.4},0).wait(1).to({regX:-24.9,regY:5.4,skewX:-5.8,skewY:174.2,x:311.7,y:195},0).wait(1).to({regX:-24.8,regY:5.6,skewX:-6.4,skewY:173.6,x:311.9,y:194.7},0).wait(49).to({regX:-26.4,skewX:-4.5,skewY:175.5,y:195.6},0).wait(1).to({regX:-24.7,regY:5.7,skewX:-2.8,skewY:177.2,x:310.2,y:196.7},0).wait(1).to({regX:-24.8,regY:5.5,skewX:-1,skewY:179,x:309.5,y:197.3},0).wait(13).to({x:309.4,y:197.6},0).wait(42).to({scaleX:0.51,skewX:-0.8,skewY:175.7,x:312.9,y:197.4},0).wait(2).to({scaleX:0.49,skewX:-1,skewY:172.2,x:316.4,y:197.1},0).wait(2).to({regX:-24.9,regY:5.6,scaleX:0.56,scaleY:0.53,skewX:-0.8,skewY:178.5,x:308.2,y:195.5},0).wait(2).to({regX:-24.8,regY:5.5,scaleX:0.64,scaleY:0.53,skewX:-1,skewY:184.7,x:299.8,y:193.7},0).wait(2).to({regX:-24.9,regY:4.8,scaleX:0.73,scaleY:0.51,skewX:1.5,skewY:183.1,x:300.9,y:191.3},0).wait(2).to({regY:5.5,scaleX:0.77,scaleY:0.5,skewX:2.8,skewY:182.3,x:301.4,y:190.6},0).wait(2).to({regX:-24.6,scaleX:0.82,scaleY:0.5,skewX:4.3,skewY:181.8,x:301.8,y:189.6},0).wait(32).to({scaleX:0.68,scaleY:0.52,skewX:1.5,skewY:180.3,x:305.6,y:193.6},0).wait(2).to({regX:-25.4,regY:5.6,scaleX:0.61,scaleY:0.53,skewX:0.3,skewY:179.7,x:307.9,y:195.8},0).wait(2).to({regX:-24.6,regY:5.4,scaleX:0.57,scaleY:0.53,skewX:-0.3,skewY:179.5,x:308.3,y:196.6},0).wait(2).to({regX:-24.8,regY:5.5,scaleX:0.54,scaleY:0.54,skewX:-1,skewY:179,x:309.4,y:197.6},0).wait(38).to({scaleX:0.51,skewX:-0.8,skewY:175.7,x:312.9,y:197.4},0).wait(2).to({scaleX:0.49,skewX:-1,skewY:172.2,x:316.4,y:197.1},0).wait(2).to({regX:-24.9,regY:5.6,scaleX:0.56,scaleY:0.53,skewX:-0.8,skewY:178.5,x:308.2,y:195.5},0).wait(2).to({regX:-24.8,regY:5.5,scaleX:0.64,scaleY:0.53,skewX:-1,skewY:184.7,x:299.8,y:193.7},0).wait(2).to({regX:-24.9,regY:4.8,scaleX:0.73,scaleY:0.51,skewX:1.5,skewY:183.1,x:300.9,y:191.3},0).wait(2).to({regY:5.5,scaleX:0.77,scaleY:0.5,skewX:2.8,skewY:182.3,x:301.4,y:190.6},0).wait(2).to({regX:-24.6,scaleX:0.82,scaleY:0.5,skewX:4.3,skewY:181.8,x:301.8,y:189.6},0).wait(12).to({scaleX:0.68,scaleY:0.52,skewX:1.5,skewY:180.3,x:305.6,y:193.6},0).wait(2).to({regX:-25.4,regY:5.6,scaleX:0.61,scaleY:0.53,skewX:0.3,skewY:179.7,x:307.9,y:195.8},0).wait(2).to({regX:-24.6,regY:5.4,scaleX:0.57,scaleY:0.53,skewX:-0.3,skewY:179.5,x:308.3,y:196.6},0).wait(2).to({regX:-24.8,regY:5.5,scaleX:0.54,scaleY:0.54,skewX:-1,skewY:179,x:309.4,y:197.6},0).wait(7));

	// Crocodile Torso
	this.croc_torso = new lib.CrocodileTorso();
	this.croc_torso.parent = this;
	this.croc_torso.setTransform(348.3,199.2,0.54,0.54,0,-1,179);
	this.croc_torso.shadow = new cjs.Shadow("rgba(0,0,0,1)",0,0,2);

	this.timeline.addTween(cjs.Tween.get(this.croc_torso).wait(4).to({skewX:-0.6,skewY:179.4,y:198.9},0).wait(2).to({skewX:-0.3,skewY:179.7,y:198.8},0).wait(2).to({skewX:-0.1,skewY:179.9,x:348.4,y:198.5},0).wait(8).to({skewX:-0.3,skewY:179.7,x:348.3,y:198.8},0).wait(2).to({skewX:-0.6,skewY:179.4,y:198.9},0).wait(2).to({skewX:-1,skewY:179,y:199.2},0).wait(49).to({skewX:-0.6,skewY:179.4,y:198.9},0).wait(1).to({skewX:-0.3,skewY:179.7,y:198.8},0).wait(1).to({skewX:-0.1,skewY:179.9,x:348.4,y:198.5},0).wait(1).to({skewX:0,skewY:180,y:198.2},0).wait(1).to({skewX:0.3,skewY:180.3,x:348.5,y:198.1},0).wait(1).to({skewX:0.5,skewY:180.5,x:348.6,y:197.8},0).wait(1).to({skewX:0.8,skewY:180.8,y:197.6},0).wait(1).to({skewX:1,skewY:181,x:348.7,y:197.4},0).wait(1).to({skewX:1.3,skewY:181.3,x:348.8,y:197.2},0).wait(49).to({skewX:0.5,skewY:180.5,x:348.6,y:197.9},0).wait(1).to({skewX:-0.1,skewY:179.9,x:348.4,y:198.5},0).wait(1).to({skewX:-1,skewY:179,y:198.9},0).wait(13).to({x:348.3,y:199.2},0).wait(42).to({scaleX:0.52,scaleY:0.56,skewX:-0.8,skewY:179.2,x:350.3,y:198.9},0).wait(2).to({scaleX:0.51,scaleY:0.58,skewX:-1,skewY:179,x:352.4,y:198.7},0).wait(2).to({scaleX:0.55,skewX:1,skewY:181,x:347.1,y:196.8},0).wait(2).to({scaleX:0.6,skewX:3,skewY:183,x:341.7,y:195},0).wait(2).to({scaleX:0.6,scaleY:0.56,skewX:1,skewY:182.3,x:340.7,y:193.7},0).wait(2).to({scaleX:0.6,scaleY:0.55,skewX:0,skewY:182,x:340.1,y:193.1},0).wait(2).to({scaleY:0.54,skewX:-1,x:339.7,y:192.4},0).wait(32).to({scaleX:0.57,skewX:-0.8,skewY:180.3,x:344,y:195.9},0).wait(2).to({scaleX:0.56,skewY:179.9,x:346.1,y:197.5},0).wait(2).to({scaleX:0.55,skewY:179.5,x:347.2,y:198.4},0).wait(2).to({scaleX:0.54,skewX:-1,skewY:179,x:348.3,y:199.2},0).wait(38).to({scaleX:0.52,scaleY:0.56,skewX:-0.8,skewY:179.2,x:350.3,y:198.9},0).wait(2).to({scaleX:0.51,scaleY:0.58,skewX:-1,skewY:179,x:352.4,y:198.7},0).wait(2).to({scaleX:0.55,skewX:1,skewY:181,x:347.1,y:196.8},0).wait(2).to({scaleX:0.6,skewX:3,skewY:183,x:341.7,y:195},0).wait(2).to({scaleX:0.6,scaleY:0.56,skewX:1,skewY:182.3,x:340.7,y:193.7},0).wait(2).to({scaleX:0.6,scaleY:0.55,skewX:0,skewY:182,x:340.1,y:193.1},0).wait(2).to({scaleY:0.54,skewX:-1,x:339.7,y:192.4},0).wait(12).to({scaleX:0.57,skewX:-0.8,skewY:180.3,x:344,y:195.9},0).wait(2).to({scaleX:0.56,skewY:179.9,x:346.1,y:197.5},0).wait(2).to({scaleX:0.55,skewY:179.5,x:347.2,y:198.4},0).wait(2).to({scaleX:0.54,skewX:-1,skewY:179,x:348.3,y:199.2},0).wait(7));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(213.5,145.9,366.3,88);


(lib.crocodile = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// mouthGlow
	this.mouthGlow = new lib.croc_mouthGlow();
	this.mouthGlow.parent = this;
	this.mouthGlow.setTransform(137.9,174.1,1.002,1.13,0,-5,-1.5,32.5,11.8);
	this.mouthGlow.alpha = 0;
	this.mouthGlow.filters = [new cjs.BlurFilter(3, 3, 1)];
	this.mouthGlow.cache(-5,-5,75,34);

	this.timeline.addTween(cjs.Tween.get(this.mouthGlow).wait(1));

	// backGlow
	this.backGlow = new lib.croc_backGlow();
	this.backGlow.parent = this;
	this.backGlow.setTransform(264.1,183.9,1,1,0,0,0,76.4,30.2);
	this.backGlow.alpha = 0;
	this.backGlow.filters = [new cjs.BlurFilter(3, 3, 1)];
	this.backGlow.cache(27,-5,121,43);

	this.timeline.addTween(cjs.Tween.get(this.backGlow).wait(1));

	// tailGlow
	this.tailGlow = new lib.croc_tailGlow();
	this.tailGlow.parent = this;
	this.tailGlow.setTransform(452.6,186.9,1,1,0,0,0,129.8,27);
	this.tailGlow.alpha = 0;
	this.tailGlow.filters = [new cjs.BlurFilter(3, 3, 1)];
	this.tailGlow.cache(1,-5,263,64);

	this.timeline.addTween(cjs.Tween.get(this.tailGlow).wait(1));

	// footGlow
	this.footGlow = new lib.croc_footGlow();
	this.footGlow.parent = this;
	this.footGlow.setTransform(287.6,216.5,1,1,0,0,0,25.9,8.7);
	this.footGlow.alpha = 0;
	this.footGlow.filters = [new cjs.BlurFilter(3, 3, 1)];
	this.footGlow.cache(-89,-10,146,32);

	this.timeline.addTween(cjs.Tween.get(this.footGlow).wait(1));

	// Layer 2
	this.foot2 = new lib.invisiblebox();
	this.foot2.parent = this;
	this.foot2.setTransform(287.9,218.1,1.341,0.41,-6.5);

	this.foot1 = new lib.invisiblebox();
	this.foot1.parent = this;
	this.foot1.setTransform(196.9,213.1,0.992,0.669);

	this.tummy = new lib.invisiblebox();
	this.tummy.parent = this;
	this.tummy.setTransform(254.1,205,1.477,0.458);

	this.tail = new lib.invisiblebox();
	this.tail.parent = this;
	this.tail.setTransform(456.6,195.1,6.216,1.204,6.5);

	this.back = new lib.invisiblebox();
	this.back.parent = this;
	this.back.setTransform(273.6,168,2.377,0.814);

	this.neck = new lib.invisiblebox();
	this.neck.parent = this;
	this.neck.setTransform(203,171.8,0.976,1.044,5.2);

	this.mouth = new lib.invisiblebox();
	this.mouth.parent = this;
	this.mouth.setTransform(137.2,172.5,1.968,1.009);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.mouth},{t:this.neck},{t:this.back},{t:this.tail},{t:this.tummy},{t:this.foot1},{t:this.foot2}]}).wait(1));

	// main
	this.main = new lib.Croc();
	this.main.parent = this;
	this.main.setTransform(-200.4,-39.7,1.386,1.386,0,0,0,20.4,55.3);

	this.timeline.addTween(cjs.Tween.get(this.main).wait(1));

}).prototype = getMCSymbolPrototype(lib.crocodile, new cjs.Rectangle(83,105.9,508.2,128.3), null);


// stage content:
(lib.MWcroc = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = null;
// library properties:
lib.properties = {
	width: 600,
	height: 307,
	fps: 30,
	color: "#FFFFFF",
	opacity: 1.00,
	manifest: [
		{src:"../../../deploy/assets/images/MWcroc_atlas_.png?1528310282245", id:"MWcroc_atlas_"}
	],
	preloads: []
};




})(lib_Croc = lib_Croc||{}, images = images||{}, createjs = createjs||{}, ss = ss||{}, AdobeAn = AdobeAn||{});
var lib_Croc, images, createjs, ss, AdobeAn;